// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-30T22:31:08.498Z
// Property: Switchyard (ID: 5710961784651776)
// Collections: 25 amenities, 23 floorplans (live), 22 photos, 79 POIs, 4 reviews, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5710961784651776",
  "property_external_id": "4881703",
  "property_zillow_url": "https://www.zillow.com/apartments/carrollton-tx/1199-n-broadway-st/9Ss4gn/",
  "property_apartments_url": "https://www.apartments.com/switchyard-carrollton-tx/nfecnln",
  "property_google_business_url": "https://www.google.com/maps/place/Switchyard/@32.9553437,-96.9122698,17z/data=!4m13!1m7!3m6!1s0x864c263d5513e277:0x4b75c21f8487ffb5!2s1199+N+Broadway+St,+Carrollton,+TX+75006!3b1!8m2!3d32.9553437!4d-96.9100758!3m4!1s0x864c263d5525de77:0x37f1c0883a198eab!8m2!3d32.9553299!4d-96.9101587",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443948917",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "switchyard",
  "property_name": "Switchyard",
  "property_website_url": "https://www.switchyardliving.com",
  "property_domain": "https://www.switchyardliving.com/",
  "property_address": "1199 N Broadway St",
  "property_full_address": "1199 N Broadway St, Carrollton, TX 75006",
  "property_address_1": "1199 N Broadway St",
  "property_address_2": null,
  "property_address_city": "Carrollton",
  "property_address_state": "TX",
  "property_address_zip_full": "75006-3852",
  "property_address_zip": "75006",
  "property_address_country": "US",
  "property_address_county": "Dallas County",
  "property_neighborhood_address": "Original Town",
  "property_address_latitude": "32.9554617",
  "property_address_longitude": "-96.9097717",
  "property_email": "switchyard@alapts.com",
  "property_phone": "(972) 695-6323",
  "property_call_tracking_phone": "469-485-1934",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Downtown Carrollton style, polished for everyday ease.</strong> Switchyard pairs modern industrial character with studio, one-, and two-bedroom apartments featuring elevated finishes, in-home washer and dryer convenience, and connected community spaces made for effortless living.</p>",
  "property_long_description": "<p><strong>Downtown Carrollton, with a modern industrial edge.</strong> Switchyard puts you close to Historic Downtown Carrollton Square, the DART Downtown Carrollton Station, I-35E, neighborhood dining, local shops, 3 Nations Brewing, and Pioneer Park—so your everyday routine can move easily from commute to coffee to dinner on the Square.</p><p>Inside, choose from studio, one-bedroom, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with elevated finishes like marble countertops, stainless steel appliances, decorative subway tile, built-in wine racks, custom Elfa closet systems, USB outlets, and in-home washer and dryer convenience. Around the community, <a href=\"/amenities\">amenities</a> make it easy to settle in and stay connected, from the resort-style pool, poolside grills, outdoor fireplace, and fitness center to the tech lounge with Wi-Fi, java bar, gaming area, bike storage and repair, Luxer package lockers, and pet washing station. At Switchyard, you get the character of Downtown Carrollton with the polished comfort of a contemporary apartment community.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019d02f1-d6ed-75bf-b24a-bf47aae56823.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island.",
    "public_id": "019d02f1-d6ed-75bf-b24a-bf47aae56823",
    "storage_key": "property/5710961784651776/019d02f1-d6ed-75bf-b24a-bf47aae56823.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "234",
  "property_year_built": "2019",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.01709401709401",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8786073.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://switchyardapts.loftliving.com/login",
  "property_apply_now_url": "https://8786073.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019d02f1-2d8f-7154-9f4d-0b91882f62eb.webp",
  "property_primary_logo_media": {
    "alt_text": "Switchyard Premier Apartments logo with a train.",
    "public_id": "019d02f1-2d8f-7154-9f4d-0b91882f62eb",
    "storage_key": "property/5710961784651776/019d02f1-2d8f-7154-9f4d-0b91882f62eb.webp",
    "width": 1737,
    "height": 1654
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e702d-5fd8-775f-bcf0-f8ec98d6ccae.webp",
  "property_secondary_logo_media": {
    "alt_text": "Switchyard Premier Apartments logo with a train.",
    "public_id": "019e702d-5fd8-775f-bcf0-f8ec98d6ccae",
    "storage_key": "property/5710961784651776/019e702d-5fd8-775f-bcf0-f8ec98d6ccae.webp",
    "width": 1737,
    "height": 1654
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e702d-61f2-70da-b5e5-9eaae25d82a1.webp",
  "property_icon_media": {
    "alt_text": "Switchyard Premier Apartments logo with a train.",
    "public_id": "019e702d-61f2-70da-b5e5-9eaae25d82a1",
    "storage_key": "property/5710961784651776/019e702d-61f2-70da-b5e5-9eaae25d82a1.webp",
    "width": 2408,
    "height": 2407
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e702d-61f2-70da-b5e5-9eaae25d82a1.webp",
  "property_fav_icon_media": {
    "alt_text": "Switchyard Premier Apartments logo with a train.",
    "public_id": "019e702d-61f2-70da-b5e5-9eaae25d82a1",
    "storage_key": "property/5710961784651776/019e702d-61f2-70da-b5e5-9eaae25d82a1.webp",
    "width": 2408,
    "height": 2407
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f4357-7b31-7589-887e-aff2931eb716.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f4357-7b31-7589-887e-aff2931eb716",
    "storage_key": "property/5710961784651776/019f4357-7b31-7589-887e-aff2931eb716.webp",
    "width": 1280,
    "height": 1218
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f4357-6ff8-76ca-9bfc-7a230ec166db.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4357-6ff8-76ca-9bfc-7a230ec166db",
    "storage_key": "property/5710961784651776/019f4357-6ff8-76ca-9bfc-7a230ec166db.webp",
    "width": 1280,
    "height": 1218
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#ffa300",
  "property_secondary_color": "#b3272d",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#939393",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "525 - 1262",
  "property_sqft_min": "525",
  "property_sqft_max": "1262",
  "property_price_range": "976.5 - 2476.5",
  "property_price_min": "976.5",
  "property_price_max": "2476.5",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/SwitchyardApts",
  "property_instagram_url": "https://www.instagram.com/SwitchyardApts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJd94lVT0mTIYRq44ZOojA8Tc",
  "property_youtube_url": "https://www.youtube.com/channel/UCeoGlqp8j3enydc24xi38AQ",
  "property_yelp_url": "https://www.yelp.com/biz/switchyard-by-lpg-carrollton",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished spaces with purpose.</strong> Grab coffee at the Java bar, settle into the Wi-Fi tech lounge, meet in conference rooms, or unwind by the pool, outdoor fireplace, and BBQ grills.</p><p>Inside, Switchyard adds everyday shine with marble countertops, stainless steel appliances, built-in wine racks, custom Elfa closets, in-home laundry, USB outlets, and select homes with oversized balconies, soaking tubs, glass-enclosed showers, or ceilings up to 12 feet.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room for your routine.</strong> Switchyard offers studio, one-, and two-bedroom apartments in Downtown Carrollton, with smart layouts and standout finishes like marble countertops, stainless steel appliances, subway tile, built-in wine racks, Elfa closet systems, and in-home washers and dryers. Select homes add balconies, pool views, island kitchens, walk-in closets, soaking tubs, or ceilings up to 12 feet.</p>",
  "property_home_gallery_blurb": "<p><strong>See Switchyard in sharp focus.</strong> Browse polished kitchens with gray cabinetry, marble-style counters, and stainless steel appliances, plus bright living spaces with bold blue accents and balcony light. Outside, preview the resort-inspired pool with in-pool loungers, grills, and covered fireplace seating, then step into amenity spaces like the clubroom, tech lounge, fitness studio, and game room.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Downtown Carrollton starts just outside your door.</strong> Wander to the brick-paved Square for Cane Rosso, Babe’s, Lemma Coffee, Pocket Sandwich Theatre, and Beth Marie’s, then catch local favorites like TEXFest and the Festival at the Switchyard. DART’s Downtown Carrollton Station adds easy Green Line and Silver Line connections to Dallas, Plano, Addison, Grapevine, and DFW Airport.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the service, spaces, and Downtown Carrollton setting.</strong> Reviews often spotlight Switchyard’s helpful front office, quick and courteous maintenance, clean community areas, and smooth move-in experiences. Favorite details include the nearby rail connection, fitness center, pet wash, bike shop, pool, and lounge spaces—offering a real glimpse of everyday life at Switchyard.</p>",
  "property_neighborhood_blurb": "<p><strong>Downtown Carrollton is more than close—it’s part of your everyday map.</strong> From Switchyard, you can drift toward the brick-paved Square for Neapolitan pizza at Cane Rosso, comfort-food nights at Babe’s, coffee at Lemma, a show at Pocket Sandwich Theatre, or a scoop from Beth Marie’s. The neighborhood keeps its railroad-era character lively with seasonal favorites like TEXFest and the Festival at the Switchyard, while nearby trail connections and A.W. Perry Homestead Museum add easy ways to slow down.</p><p>When you want to range farther, Downtown Carrollton Station connects you to the DART Green Line and Silver Line for Dallas, Plano, Addison, Grapevine, and DFW Airport access. After exploring the map, <a href=\"/schedule-a-tour\">schedule a tour</a> and see how Switchyard fits into the downtown rhythm.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your day moving.</strong> At Switchyard, the community spaces feel as useful as they are polished: start with coffee at the Java bar, plug in at the tech lounge with Wi-Fi, meet in the conference rooms, or reset by the pool, outdoor fireplace, and poolside BBQ grills.</p><p>Back at home, elevated details add everyday ease—think marble countertops, stainless steel appliances, built-in wine racks, custom Elfa closet systems, in-home washer and dryer convenience, USB outlets, and select-home extras like extra-large balconies, glass-enclosed showers, soaking tubs, or ceilings up to 12 feet. Practical perks round it out, from Luxer package lockers and door-to-door trash pickup to bike storage and a pet washing station. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Your next home starts here.</strong> Apply online for a studio, one-, or two-bedroom apartment with modern industrial character, polished finishes, and everyday conveniences like stainless steel appliances, custom closets, and in-home washer and dryer. Switchyard brings contemporary comfort to Downtown Carrollton living—start your application today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the Switchyard leasing team for help finding your way to our Downtown Carrollton community, exploring studio, one-, and two-bedroom floor plans, or learning more about our modern industrial apartment features.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Switchyard?</strong> Start here for quick answers on leasing, floor plans, amenities, and everyday living in our Downtown Carrollton apartment community. If you do not see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find your right fit at Switchyard.</strong> Browse studio, one-bedroom, and two-bedroom apartments in Downtown Carrollton with layouts that make the most of every inch—from streamlined studios to larger two-bedroom homes with room to spread out. As you compare availability, look for details that add everyday polish: <a href=\"/amenities\">marble countertops</a>, stainless steel appliances, decorative subway tile, built-in wine racks, custom Elfa closet systems, in-home washer and dryer convenience, and ceiling heights that can reach up to 12 feet in select homes.</p><p>Choose the features that matter most to you, whether that means a balcony, pool view, corner layout, island kitchen, walk-in closet, glass-enclosed shower, or soaking tub. Ready to see the space in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> today.</p>",
  "property_gallery_blurb": "<p><strong>Picture your everyday backdrop at Switchyard.</strong> In the gallery, polished interiors and relaxed amenity spaces come into focus: gray-cabinet kitchens with marble-style counters and stainless steel appliances, living rooms with bold blue accents and balcony light, and bedrooms styled with rich color. Follow the camera outside to the <a href=\"/amenities\">resort-inspired pool</a>, in-pool loungers, poolside grills, and covered fireplace seating, then look inside at the clubroom, tech lounge, fitness studio, and game room with room to unwind. From modern finishes to shared spaces with personality, these photos give you a closer look at apartment living in Carrollton. Want the full perspective? Explore <a href=\"/virtual-tours\">virtual tours</a> or schedule a visit.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Switchyard on the map.</strong> Browse available apartments, then zoom out to see how this modern Downtown Carrollton address connects you to nearby transit, dining, shops, parks, and everyday stops—all with the industrial-edged character and contemporary comfort that define Switchyard.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living feels built in at Switchyard.</strong> Your cat or dog can settle into a home with everyday conveniences that make pet life easier, from hard-surface flooring in many layouts to balconies or patios in select homes. After a muddy walk or a fresh-air outing, the on-site <a href=\"/amenities\">pet washing station</a> helps keep cleanup simple without turning your bathroom into the grooming spot.</p><p>When it is time to get outside, Downtown Carrollton gives you a walkable setting for quick leash breaks, and the city offers nearby off-leash dog park options for more room to roam. With cats and dogs welcome, up to two pets per home, and no weight limit, Switchyard makes it easier to choose an apartment that works for the whole household. Have a specific pet-policy question? <a href=\"/contact-us\">Contact the leasing team</a> before you tour.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Switchyard experience.</strong> If you love the modern industrial edge, Downtown Carrollton character, polished apartment finishes, and connected community spaces, invite a friend to see what makes life here stand out.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Switchyard.</strong><br>Keep everyday apartment living moving with quick access to pay rent, submit maintenance requests, and manage your account—simple support for the polished comfort and modern industrial edge of life in Downtown Carrollton.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Switchyard.</strong> As you browse the reviews, you’ll notice a clear theme: responsive service, clean spaces, and a team that makes daily living easier. Residents often call out the front office for being kind, professional, and helpful, while maintenance earns praise for being “quick, timely, courteous and they communicate.”</p><p>Reviews also highlight the energy of Downtown Carrollton living, the convenience of the nearby rail connection, and favorite community features like the fitness center, pet wash, bike shop, pool, and lounge spaces. From smooth move-in experiences to thoughtful follow-through on work orders, Switchyard’s reviews offer a real look at what it’s like to call this apartment community home.</p>",
  "property_created_at": "1752256581581",
  "property_scheduletour_blurb": "<p><strong>See Switchyard in person.</strong> Tour studio, one-, and two-bedroom apartments with marble countertops, stainless steel appliances, subway tile, Elfa closet systems, USB outlets, and in-home laundry—then get a feel for the modern industrial style and connected Downtown Carrollton setting that make this community stand out.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture life at Switchyard: modern industrial style, polished apartment finishes, and the easy comfort of a Downtown Carrollton setting designed for connected, everyday living.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a closer look before you visit.</strong> Switchyard’s virtual tours let you move through the spaces that matter most from wherever you are. Start with the community tours to preview the atmosphere, shared spaces, and modern industrial style that shape the property, then step into the 1BR A4 apartment tour for a room-by-room feel of the layout, finishes, and everyday flow.</p><p>As you explore, notice the details that are easier to understand in motion: open living areas, a polished kitchen, in-home convenience, and the way each space connects. Use the tours alongside the <a href=\"/gallery\">photo gallery</a> and <a href=\"/floor-plans\">floor plan options</a> to narrow your search, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Switchyard in Carrollton in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Switchyard",
  "property_seo_title_home": "Switchyard | Apartments in Carrollton, TX",
  "property_seo_description_home": "Discover your perfect home at Switchyard in Carrollton, TX! Choose from spacious floor plans including one-bedroom, two-bedroom, and studio apartments, all featuring modern amenities like smart locks, USB outlets, and walk-in closets. Enjoy our luxurious community perks, from a sparkling pool and fitness center to a cozy coffee bar and outdoor lounges with fireplaces. With online resident services, bike storage, and additional storage units, convenience is at your fingertips. Ready to elevate your living experience? Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Carrollton, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Switchyard in Carrollton, TX! Explore our diverse floor plans including cozy studios, spacious one-bedroom, and two-bedroom apartments. Browse our available homes today and find the perfect fit for your lifestyle! Your dream apartment awaits at Switchyard. ",
  "property_seo_title_amenities": "Amenities | Carrollton, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal living space at Switchyard, an exceptional apartment community in Carrollton, TX. Choose from thoughtfully designed one-bedroom, two-bedroom, and studio floor plans that cater to your every need. Enjoy top-notch amenities including a modern fitness center, inviting coffee bar, and relaxing lounge areas with fireplaces. With features like smart locks, USB outlets, and private balconies, your comfort is our priority. Explore outdoor gaming, a poolside paradise, and convenience with LUXER Package Lockers and online resident services. Visit our Amenities page today and experience the vibrant community at Switchyard!",
  "property_seo_title_gallery": "Gallery | Apartments in Carrollton, TX",
  "property_seo_description_gallery": "\"Discover your perfect home at Switchyard in Carrollton, TX! Explore our stunning photo gallery showcasing a variety of floor plans, including one-bedroom, two-bedroom, and studios. Enjoy premium amenities like a state-of-the-art fitness center, relaxing pool, and our inviting coffee bar. Picture yourself living in style with features like smart locks, walk-in closets, and private balconies. Don't miss the outdoor lounge with a fireplace and the vibrant community atmosphere. Your dream apartment awaits—view all today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Switchyard Apartments",
  "property_seo_description_virtualtours": "\"Discover your perfect home at Switchyard in Carrollton, TX! Explore our diverse floor plans, including one-bedroom, two-bedroom, and studio apartments. Take a virtual tour today and experience all that our vibrant community has to offer! Your ideal living space awaits—see it now!\"",
  "property_seo_title_interactivemap": "Interactive Map | Switchyard Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Switchyard in Carrollton, TX! Our community offers a diverse selection of floor plans, including stunning one-bedroom, two-bedroom, and studio options. Enjoy unparalleled amenities like a luxurious pool, fitness center, and outdoor lounge with a fireplace. With features like smart locks, USB outlets, and walk-in closets, you’ll find everything you need for a comfortable lifestyle. Explore our interactive community map to search available apartments, view pricing, and take the first step toward your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Carrollton, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood around Switchyard in Carrollton, TX! Explore our one-bedroom, two-bedroom, and studio floor plans, and dive into local favorites and nearby attractions. See what’s around our community today and experience the perfect blend of comfort and convenience!",
  "property_seo_title_contact": "Contact Us | Switchyard",
  "property_seo_description_contact": "Discover your perfect home at Switchyard in Carrollton, TX! Choose from our stylish one-bedroom, spacious two-bedroom, or cozy studio floor plans. Have questions? Our friendly leasing team is here to assist you—contact us today to learn more about our welcoming community!",
  "property_seo_title_faqs": "FAQs | Apartments in Carrollton, TX",
  "property_seo_description_faqs": "Discover your perfect home at Switchyard in Carrollton, TX! Choose from a variety of floor plans, including stylish one and two-bedroom apartments and cozy studios. Enjoy premium amenities like a fitness center, coffee bar, outdoor gaming, and a refreshing pool. With features such as smart locks, walk-in closets, and private balconies, convenience meets luxury. Have questions? Browse our FAQs page for answers on our community and start your journey to comfortable living today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Carrollton, TX",
  "property_seo_description_reviews": "Experience luxury living at Switchyard in Carrollton, TX! Our diverse floor plans—including studio, one-bedroom, and two-bedroom options—offer something for everyone. Enjoy top-notch amenities like a fitness center, pool, coffee bar, and outdoor lounge with a fireplace. Our modern apartments feature smart locks, USB outlets, and walk-in closets for ultimate convenience. Ready to make Switchyard your home? See what our residents have to say about living in this vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Carrollton, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Switchyard, a vibrant apartment community in Carrollton, TX. Choose from spacious one-bedroom, two-bedroom, or stylish studio floor plans, each enhanced with modern amenities like smart locks, high ceilings, private balconies, and a luxurious pool. Enjoy top-notch facilities including a state-of-the-art fitness center, outdoor gaming areas, and a cozy coffee bar. Apply now and explore your future home, complete with convenient online resident services and more. Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Switchyard",
  "property_seo_description_residentaccess": "\"Welcome to the Switchyard Resident Portal in Carrollton, TX! Easily access your account to pay rent, schedule maintenance, and manage community updates. Log in now for a seamless living experience at Switchyard!\"",
  "property_seo_title_referafriend": "Refer A Friend | Switchyard",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Switchyard in Carrollton, TX, and help them discover their new home. Enjoy exclusive rewards and share the vibrant community you love. Join us today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Switchyard",
  "property_seo_description_scheduletour": "\"Discover your ideal home at Switchyard in Carrollton, TX! Schedule a tour today to explore our vibrant apartment community, featuring modern amenities and a welcoming atmosphere. Don't miss the chance to see why Switchyard is the perfect place to call home!\"",
  "property_seo_title_privacy": "Privacy Policy | Switchyard",
  "property_seo_description_privacy": "Discover peace of mind at Switchyard in Carrollton, TX. Our Privacy Policy ensures your information is protected while you enjoy the comfort of our vibrant apartment community. **View our privacy policy** today to learn how we safeguard your data!",
  "property_seo_title_accessibility": "Website Accessibility | Switchyard",
  "property_seo_description_accessibility": "Discover Switchyard in Carrollton, TX, where we prioritize digital inclusion for all. Our Accessibility Statement outlines our commitment to providing an inclusive online experience for everyone. Join us in creating a welcoming community—learn more today!",
  "property_seo_title_sitemap": "Sitemap | Switchyard",
  "property_seo_description_sitemap": "Discover the ultimate living experience at Switchyard in Carrollton, TX. Explore our comprehensive sitemap to easily navigate our apartment community and find your perfect home. View our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | Switchyard",
  "property_seo_description_thankyou": "Thank you for your interest in Switchyard Apartments in Carrollton, TX! We appreciate your submission. A member of our team will reach out shortly to assist you in finding your perfect home. Stay tuned for more updates and personalized support!",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320323",
  "amenities": [
    {
      "id": "custom_ea2da149-c1c9-472a-a695-50969ef99bbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "LUXER Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7145be8-bdfc-4ed7-82cb-7b86b1c34fb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e6dea818-e19c-446d-a879-4b6786c1cd73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Java Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ead1356-1a6d-4f9d-8d4a-e26d1dd39bb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Marble Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e1a4350-0b76-4928-be6e-e4ee13a2f35d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Interactive Fitness Studio w/Fitness On-Demand",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69f75537-abff-43cc-a182-e3d3891c74a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5cc22bf-9b83-4511-b237-0558e96b8173",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22f2e4d4-d3e3-4355-8acb-77d5c9db38bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ae681f7-3d4d-4455-b2cb-3b649f10c233",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000661",
      "title": "Outdoor Gaming",
      "amount": "0.0000",
      "description": "Gaming Area w/ Shuffleboard, Skee ball & Golden Tee",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54d1c246-6ba9-4692-95d5-c9c2784dcc0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Balcony*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b42a535-387f-4dc4-b8a8-e387fefa1338",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/Clubhouse & Outdoor Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5f97754-89f3-4a91-8209-72cdd9bb1a4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_deaa4042-f464-4503-93cc-48239da05926",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9' to 12' Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d8d6d26-f112-43c5-8119-e436fea40821",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59c96b3f-25b0-4f71-9907-beb5ae37d0c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Soaking Tubs*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2862665b-c252-4ccd-83bc-f12bdd035683",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b6d2cfd-a65b-434b-ab2b-ac0f0e2636b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer & Dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba28d2a9-45df-4560-a1bf-c0ab3e9b184b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Custom elfa Closet Systems",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44841f41-9b30-4f13-b7fc-f1282fad1cbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Poolside BBQ Grills",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d74b530-3a8a-4542-a097-76ece73e5bfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Tech Lounge w/ Wi-Fi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9326c69d-5821-4fcf-9ef2-833fb99aea61",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000002333",
      "title": "Wine Rack",
      "amount": "0.0000",
      "description": "Built-In Wine Racks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9af61308-ed71-4948-925b-4c18b50cefec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000002334",
      "title": "Resident Convenience Store",
      "amount": "0.0000",
      "description": "Community Market",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccef9248-7f48-4eb1-98b1-73adc1f35195",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000002369",
      "title": "Mud Room",
      "amount": "0.0000",
      "description": "Modern Mudrooms*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0f6644a-8a72-407b-af1e-0792feb10a37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000002447",
      "title": "Bike Storage and Repair Area",
      "amount": "0.0000",
      "description": "Bike Storage and Repair Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_891e7fd9-f6f5-4e09-b3ae-52aedaa5a699",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "external_id": "P000002541",
      "title": "Outdoor Lounge with Fireplace",
      "amount": "0.0000",
      "description": "Outdoor Fireplace & Seating Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_51f81593-a09e-4b7c-b7aa-3cce15888ba3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-327c-7248-8bb3-0c2eef6223d1.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with fireplace and seating.",
        "public_id": "019e89b1-327c-7248-8bb3-0c2eef6223d1",
        "storage_key": "property/5710961784651776/019e89b1-327c-7248-8bb3-0c2eef6223d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the ambiance of the outdoor fireplace and comfortable seating in our community lounge area.",
      "link": "",
      "alt_text": "Outdoor lounge area with fireplace and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79b15403-cd66-4df0-80fa-4054c7f70272",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-3ba7-7688-b08f-5da7df419553.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a plush blue velvet bed, orange accent chair, and artistic wall decor.",
        "public_id": "019e89b1-3ba7-7688-b08f-5da7df419553",
        "storage_key": "property/5710961784651776/019e89b1-3ba7-7688-b08f-5da7df419553.webp",
        "width": 2689,
        "height": 1793
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a king-size bed, elegant furnishings, and vibrant decor for a truly relaxing atmosphere.",
      "link": "",
      "alt_text": "Luxurious bedroom with a plush blue velvet bed, orange accent chair, and artistic wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60ac077b-613c-46f0-a230-30e93fca35cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-4493-7065-8a78-4c9deb2d4600.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e89b1-4493-7065-8a78-4c9deb2d4600",
        "storage_key": "property/5710961784651776/019e89b1-4493-7065-8a78-4c9deb2d4600.webp",
        "width": 2606,
        "height": 1738
      },
      "title": "Apartment",
      "description": "View of a stylish open-concept apartment kitchen featuring light gray cabinetry, a microwave, oven, refrigerator, and a spacious island with bar stools.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39854f06-4d9c-401e-845f-1d5ad77cba99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-3b2d-765a-82b4-90f3ec6bf4db.webp",
      "image_media": {
        "alt_text": "Modern community lounge with brick accent wall, large screen TV, and plush seating.",
        "public_id": "019e89b1-3b2d-765a-82b4-90f3ec6bf4db",
        "storage_key": "property/5710961784651776/019e89b1-3b2d-765a-82b4-90f3ec6bf4db.webp",
        "width": 2518,
        "height": 1679
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a striking brick wall, comfortable seating, and a large entertainment screen.",
      "link": "",
      "alt_text": "Modern community lounge with brick accent wall, large screen TV, and plush seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f37b1d0-a129-4eb4-98ff-2342328d5ce2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-3b80-72c6-8d7d-56977deb5678.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with plush sofas, armchairs, and decorative pillows in a modern lounge.",
        "public_id": "019e89b1-3b80-72c6-8d7d-56977deb5678",
        "storage_key": "property/5710961784651776/019e89b1-3b80-72c6-8d7d-56977deb5678.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable resident lounge, featuring ample seating and chic decor for a perfect gathering space.",
      "link": "",
      "alt_text": "Comfortable seating area with plush sofas, armchairs, and decorative pillows in a modern lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c562dc3-ecdc-4888-9de9-2876f29c9824",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-37a9-7498-9f9d-0ebae3797f7e.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of a luxury apartment with modern furniture and decor.",
        "public_id": "019e89b1-37a9-7498-9f9d-0ebae3797f7e",
        "storage_key": "property/5710961784651776/019e89b1-37a9-7498-9f9d-0ebae3797f7e.webp",
        "width": 2610,
        "height": 1740
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed apartment, featuring a spacious living area and a serene bedroom, perfect for relaxation and modern living.",
      "link": "",
      "alt_text": "Living room and bedroom of a luxury apartment with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a114384-1c5d-48ba-84df-8e16079bf6b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-2ffd-768d-8cd7-148b861236b2.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
        "public_id": "019e89b1-2ffd-768d-8cd7-148b861236b2",
        "storage_key": "property/5710961784651776/019e89b1-2ffd-768d-8cd7-148b861236b2.webp",
        "width": 2641,
        "height": 1760
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and weight training equipment for resident use.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb1d4477-232e-4b44-84cc-b3ff51364994",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-2103-72e1-a313-f6a076299e17.webp",
      "image_media": {
        "alt_text": "Community lounge area with a ping pong table, pool table, and bar.",
        "public_id": "019e89b1-2103-72e1-a313-f6a076299e17",
        "storage_key": "property/5710961784651776/019e89b1-2103-72e1-a313-f6a076299e17.webp",
        "width": 2596,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our community lounge, featuring a ping pong table, billiards table, and a stylish bar area perfect for socializing. Step outside to the pool area.",
      "link": "",
      "alt_text": "Community lounge area with a ping pong table, pool table, and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3225c4dc-60b3-4a49-b85d-70c54944dd6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-191d-7375-b997-690424d723c3.webp",
      "image_media": {
        "alt_text": "Stylish living room with a brown leather sofa, navy blue accent wall with modern art, and an open-concept kitchen.",
        "public_id": "019e89b1-191d-7375-b997-690424d723c3",
        "storage_key": "property/5710961784651776/019e89b1-191d-7375-b997-690424d723c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully designed apartment, featuring a spacious living area and a modern, open-concept kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Stylish living room with a brown leather sofa, navy blue accent wall with modern art, and an open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7aa3480f-4521-42e1-949a-22247332b2a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-2f90-76ef-82d4-893952a777ec.webp",
      "image_media": {
        "alt_text": "Community lounge area with a TV, coffee station, and seating.",
        "public_id": "019e89b1-2f90-76ef-82d4-893952a777ec",
        "storage_key": "property/5710961784651776/019e89b1-2f90-76ef-82d4-893952a777ec.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a modern TV, a convenient coffee station, and comfortable seating arrangements for residents.",
      "link": "",
      "alt_text": "Community lounge area with a TV, coffee station, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d694ca31-27ae-47c4-9451-50b4b94ed6f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-2ef4-737c-8335-be1b47af92c3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island with seating.",
        "public_id": "019e89b1-2ef4-737c-8335-be1b47af92c3",
        "storage_key": "property/5710961784651776/019e89b1-2ef4-737c-8335-be1b47af92c3.webp",
        "width": 2635,
        "height": 1758
      },
      "title": "Apartment",
      "description": "Beautifully designed kitchen featuring ample cabinet space, a sleek island perfect for casual dining, and modern stainless steel appliances. Ideal for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9d2ce0c1-be9c-43a5-869e-9a42135005e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-0b21-735c-81a4-59339cc86b5b.webp",
      "image_media": {
        "alt_text": "Community lounge with bar, seating, TVs, and arcade game.",
        "public_id": "019e89b1-0b21-735c-81a4-59339cc86b5b",
        "storage_key": "property/5710961784651776/019e89b1-0b21-735c-81a4-59339cc86b5b.webp",
        "width": 2564,
        "height": 1711
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the community lounge, featuring a full-service bar, comfortable seating, multiple televisions, and an arcade game for entertainment.",
      "link": "",
      "alt_text": "Community lounge with bar, seating, TVs, and arcade game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28de2c21-f317-4b13-b8ab-8b70828c2dc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-0726-76d9-bd3f-64f7205aa87f.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with red accent wall, comfortable seating, and modern decor.",
        "public_id": "019e89b1-0726-76d9-bd3f-64f7205aa87f",
        "storage_key": "property/5710961784651776/019e89b1-0726-76d9-bd3f-64f7205aa87f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed lounge area, perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Stylish lounge area with red accent wall, comfortable seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19cbd61c-085a-42e9-b1d5-d60d402e8061",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-1851-70d9-83aa-53f6e222e902.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
        "public_id": "019e89b1-1851-70d9-83aa-53f6e222e902",
        "storage_key": "property/5710961784651776/019e89b1-1851-70d9-83aa-53f6e222e902.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by lush landscaping and ample seating for relaxation. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_599d3834-1143-470d-afb8-75b51857845a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b1-06c6-7558-8854-9a3f1f1938af.webp",
      "image_media": {
        "alt_text": "Community lounge area with pool table, bar seating, and view of outdoor pool.",
        "public_id": "019e89b1-06c6-7558-8854-9a3f1f1938af",
        "storage_key": "property/5710961784651776/019e89b1-06c6-7558-8854-9a3f1f1938af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community lounge featuring a pool table, bar seating, and a view of the sparkling outdoor pool. Perfect for socializing and relaxation.",
      "link": "",
      "alt_text": "Community lounge area with pool table, bar seating, and view of outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89236daa-473c-4489-abe1-2216c97107d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fee4-76e8-9e30-0d4b0a5f25e3.webp",
      "image_media": {
        "alt_text": "Bicycles stored in a bike rack in a residential building.",
        "public_id": "019e89b0-fee4-76e8-9e30-0d4b0a5f25e3",
        "storage_key": "property/5710961784651776/019e89b0-fee4-76e8-9e30-0d4b0a5f25e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure bicycle storage is available for residents, making it easy to explore the neighborhood on two wheels.",
      "link": "",
      "alt_text": "Bicycles stored in a bike rack in a residential building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72756dc1-4548-473c-8718-f01e13364464",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fdb9-73cc-946a-5b111f78a589.webp",
      "image_media": {
        "alt_text": "Living room with a tan leather sofa, blue accent wall, and large Texas map.",
        "public_id": "019e89b0-fdb9-73cc-946a-5b111f78a589",
        "storage_key": "property/5710961784651776/019e89b0-fdb9-73cc-946a-5b111f78a589.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable tan leather sofa, vibrant blue walls, and a decorative Texas map. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a tan leather sofa, blue accent wall, and large Texas map.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d07eeeeb-d602-4934-a239-d0ffa88ffa35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fd70-726c-a44c-7e9f6c84a517.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with Technogym equipment including weight machines, treadmills, and a stair climber.",
        "public_id": "019e89b0-fd70-726c-a44c-7e9f6c84a517",
        "storage_key": "property/5710961784651776/019e89b0-fd70-726c-a44c-7e9f6c84a517.webp",
        "width": 2601,
        "height": 1734
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of Technogym cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment gym with Technogym equipment including weight machines, treadmills, and a stair climber.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fab142e3-fbc0-4779-8a76-d64390bdfe0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fd70-726c-a44c-79fdcc8601af.webp",
      "image_media": {
        "alt_text": "Bar area with stools and seating area with tables and chairs.",
        "public_id": "019e89b0-fd70-726c-a44c-79fdcc8601af",
        "storage_key": "property/5710961784651776/019e89b0-fd70-726c-a44c-79fdcc8601af.webp",
        "width": 2521,
        "height": 1680
      },
      "title": "Community",
      "description": "Enjoy the community bar area, perfect for entertaining guests or relaxing with friends.",
      "link": "",
      "alt_text": "Bar area with stools and seating area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50f3c52a-8f06-481b-b61d-e807968781c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fcd1-720e-8dd7-8c2045370074.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and waterfalls.",
        "public_id": "019e89b0-fcd1-720e-8dd7-8c2045370074",
        "storage_key": "property/5710961784651776/019e89b0-fcd1-720e-8dd7-8c2045370074.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring comfortable lounge seating and cascading waterfalls. Perfect for a refreshing escape.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and waterfalls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d42b21f1-f68f-4cc1-b9f5-83b12be8fa42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fa4f-7543-bc57-2794de2311a4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, vanity, and walk-in closet.",
        "public_id": "019e89b0-fa4f-7543-bc57-2794de2311a4",
        "storage_key": "property/5710961784651776/019e89b0-fa4f-7543-bc57-2794de2311a4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity with a sleek countertop, a deep soaking tub with a shower, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, vanity, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e075ce2-9b04-4426-be84-941a9f12f95f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019e89b0-fa76-7158-81e1-8f9a943c2fd0.webp",
      "image_media": {
        "alt_text": "Modern lounge area with island seating, brick accent wall, and large television.",
        "public_id": "019e89b0-fa76-7158-81e1-8f9a943c2fd0",
        "storage_key": "property/5710961784651776/019e89b0-fa76-7158-81e1-8f9a943c2fd0.webp",
        "width": 2468,
        "height": 1646
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge area, featuring comfortable seating, a striking brick accent wall, and entertainment options.",
      "link": "",
      "alt_text": "Modern lounge area with island seating, brick accent wall, and large television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_66cdb4bbb17ef24d3bc4a1dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "C Square Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1101 S Broadway St #100, Carrollton, TX 75006, USA",
      "poi_short_description": "Down-to-earth cafe providing espresso drinks & breakfast/lunch eats in an airy, brick interior.",
      "poi_long_description": "Down-to-earth cafe providing espresso drinks & breakfast/lunch eats in an airy, brick interior.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-6baf-7623-b31c-6735c36be94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-6baf-7623-b31c-6735c36be94b",
        "storage_key": "property/5710961784651776/019f14fc-6baf-7623-b31c-6735c36be94b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://csquare.cafe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9215440478794939630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "c-square-cafe",
      "poi_latitude": "32.9523892",
      "poi_longitude": "-96.9078942",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-573-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-e9d5-7648-a28b-dddc4a98fc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-e9d5-7648-a28b-dddc4a98fc99",
        "storage_key": "property/5710961784651776/019f14fc-e9d5-7648-a28b-dddc4a98fc99.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ1Y_S_jwmTIYR7vxTO0rS438",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_8c5f63c8182bde55adad59fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Rainbow Fountain & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1107 S Broadway St, Carrollton, TX 75006, USA",
      "poi_short_description": "Simple, vintage-style grill & soda fountain with counter stools for American staples & milkshakes.",
      "poi_long_description": "Simple, vintage-style grill & soda fountain with counter stools for American staples & milkshakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-7d34-74a8-beb7-5df2ede6e93a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-7d34-74a8-beb7-5df2ede6e93a",
        "storage_key": "property/5710961784651776/019f14fc-7d34-74a8-beb7-5df2ede6e93a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.toasttab.com/rainbowfountainandgrill",
      "poi_directions_map_url": "https://maps.google.com/?cid=2348653566758947434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rainbow-fountain--grill",
      "poi_latitude": "32.9522238",
      "poi_longitude": "-96.9077241",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-242-1621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3nx-DwmTIYRagofq_kXmCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_3a7aae0e162477c14083a313",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Pour Choices",
      "poi_type": "Restaurants",
      "poi_address": "1107 S Broadway St, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-5cc8-75d7-baeb-1d7592e6e0f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5cc8-75d7-baeb-1d7592e6e0f6",
        "storage_key": "property/5710961784651776/019f14fc-5cc8-75d7-baeb-1d7592e6e0f6.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://pourchoicesbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14797588242506081175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pour-choices",
      "poi_latitude": "32.9522206",
      "poi_longitude": "-96.9077422",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-695-6108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea37-762e-9bab-24bbd667c73c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea37-762e-9bab-24bbd667c73c",
        "storage_key": "property/5710961784651776/019f14fc-ea37-762e-9bab-24bbd667c73c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUbZ4NEnTIYRl2MSBxuYW80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_3dbe800ccf4d0972529c3908",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Joe's Pizza Pasta & Subs",
      "poi_type": "Restaurants",
      "poi_address": "1855 E Frankford Rd #100, Carrollton, TX 75007, USA",
      "poi_short_description": "Family-run pizzeria with long happy hours offering NYC-style pies & Italian staples in basic digs.",
      "poi_long_description": "Family-run pizzeria with long happy hours offering NYC-style pies & Italian staples in basic digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-7061-7559-ada5-3473be4fb13f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-7061-7559-ada5-3473be4fb13f",
        "storage_key": "property/5710961784651776/019f14fc-7061-7559-ada5-3473be4fb13f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.joespizzapasta1988.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14771713037708409044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-pizza-pasta--subs",
      "poi_latitude": "33.00071",
      "poi_longitude": "-96.887109",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-492-1474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8GHO8glTIYR1LidcL6q_8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_dd0536d873facd67c57b61d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "EL Rincon Mexican Kitchen & Tequila Bar",
      "poi_type": "Restaurants",
      "poi_address": "1114 Elm St #100, Carrollton, TX 75006, USA",
      "poi_short_description": "Vibrant, unfussy restaurant serving up Mexican dishes as well as wine, cocktails & imported beer.",
      "poi_long_description": "Vibrant, unfussy restaurant serving up Mexican dishes as well as wine, cocktails & imported beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-71d4-725f-886c-93b596360c02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-71d4-725f-886c-93b596360c02",
        "storage_key": "property/5710961784651776/019f14fc-71d4-725f-886c-93b596360c02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elrincontx.com/carrollton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8367338563073040733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rincon-mexican-kitchen--tequila-bar",
      "poi_latitude": "32.9515979",
      "poi_longitude": "-96.9084012",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-892-6429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQchA7DwmTIYRXWFlTxfCHnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f948f58b72adca5518717449",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Barrel & Bones Craft Bar and Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "1011 S Main St Ste 110, Carrollton, TX 75006, USA",
      "poi_short_description": "Casual, contemporary, kid-friendly spot for BBQ standards like ribs and brisket plus beer, hard liquor and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-70bc-731b-9629-b1a2f2cc55ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-70bc-731b-9629-b1a2f2cc55ec",
        "storage_key": "property/5710961784651776/019f14fc-70bc-731b-9629-b1a2f2cc55ec.webp",
        "width": 909,
        "height": 1280
      },
      "poi_business_url": "https://orders.barrelandbones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11011638439150997340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrel--bones-craft-bar-and-smokehouse",
      "poi_latitude": "32.9529791",
      "poi_longitude": "-96.9064471",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 945-523-1303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-U4EZ8nTIYRXM-heNEy0Zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_60fbfcdb248931fd655eed64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Twisted Root Burger Co.",
      "poi_type": "Restaurants",
      "poi_address": "1111 S Main St Apt 1210, Carrollton, TX 75006, USA",
      "poi_short_description": "Chain with gourmet beef, turkey & vegan burgers, plus spiked shakes. Some locations have game meats.",
      "poi_long_description": "Chain with gourmet beef, turkey & vegan burgers, plus spiked shakes. Some locations have game meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-6c7e-727e-95cd-ae9213d264d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-6c7e-727e-95cd-ae9213d264d8",
        "storage_key": "property/5710961784651776/019f14fc-6c7e-727e-95cd-ae9213d264d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.twistedrootburgerco.com/locations/carrollton",
      "poi_directions_map_url": "https://maps.google.com/?cid=6202183737306148588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twisted-root-burger-co",
      "poi_latitude": "32.95252809999999",
      "poi_longitude": "-96.9064567",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-449-8498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_34SzwmTIYR7G7WnT-VElY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_e567d16d323c744864643d9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Cane Rosso",
      "poi_type": "Restaurants",
      "poi_address": "1301 S Broadway St, Carrollton, TX 75006, USA",
      "poi_short_description": "Casual pizzeria serving brick-oven pies, including desserts such as the Ladybird.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-7318-76ea-9369-e32262b72b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-7318-76ea-9369-e32262b72b1d",
        "storage_key": "property/5710961784651776/019f14fc-7318-76ea-9369-e32262b72b1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.canerosso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8684970111727338522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cane-rosso",
      "poi_latitude": "32.9512756",
      "poi_longitude": "-96.9068497",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-731-6402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6zRZzwmTIYRGoRkOk02h3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_3ae5d98d8998b60c7935d2fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Tacos and Avocados",
      "poi_type": "Restaurants",
      "poi_address": "1309 S Broadway St, Carrollton, TX 75006, USA",
      "poi_short_description": "Laid-back eatery specializing in tacos, burritos and margaritas with outdoor seating and a patio.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-6ace-7754-86c5-b15064c79fca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-6ace-7754-86c5-b15064c79fca",
        "storage_key": "property/5710961784651776/019f14fc-6ace-7754-86c5-b15064c79fca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tacosandavocados.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=719395679901502223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-and-avocados",
      "poi_latitude": "32.9510424",
      "poi_longitude": "-96.9066539",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-850-7544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSZnx-cnTIYRD8t6MY_O-wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_2ccafb2e76757b39c6f9413e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Babe's Chicken Dinner House",
      "poi_type": "Restaurants",
      "poi_address": "1006 W Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_long_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-5f33-718f-b867-8e4b910d0d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5f33-718f-b867-8e4b910d0d03",
        "storage_key": "property/5710961784651776/019f14fc-5f33-718f-b867-8e4b910d0d03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739785872141058117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-chicken-dinner-house",
      "poi_latitude": "32.9528134",
      "poi_longitude": "-96.9077799",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-245-7773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVJi_jwmTIYRRQCaFbysBSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_0387ae9956da1b6996b45e30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Brother's Pizza & Pasta",
      "poi_type": "Restaurants",
      "poi_address": "2002 N Interstate 35E, Carrollton, TX 75006, USA",
      "poi_short_description": "Pizza joint offering by-the-slice or whole thin-crust pies for dine-in or takeout, plus beer.",
      "poi_long_description": "Pizza joint offering by-the-slice or whole thin-crust pies for dine-in or takeout, plus beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-911c-7036-9e18-390f7466da13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-911c-7036-9e18-390f7466da13",
        "storage_key": "property/5710961784651776/019f14fc-911c-7036-9e18-390f7466da13.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.brotherspizzapastacarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11251253583194821600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-pizza--pasta",
      "poi_latitude": "32.968959",
      "poi_longitude": "-96.918965",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-245-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWke-AImTIYR4BMrsIV7JJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c00682409fce62a54f16bb58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "MILK T BAR",
      "poi_type": "Restaurants",
      "poi_address": "1414 S Broadway St #3-3113, Carrollton, TX 75006, USA",
      "poi_short_description": "Relaxed spot specializing in bubble tea and taiyaki along with vegetarian and vegan options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-7f50-76eb-8a49-9ec3753dd2be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-7f50-76eb-8a49-9ec3753dd2be",
        "storage_key": "property/5710961784651776/019f14fc-7f50-76eb-8a49-9ec3753dd2be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505341632546172522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "milk-t-bar",
      "poi_latitude": "32.9505494",
      "poi_longitude": "-96.9068172",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-892-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK97hb5onTIYRam79YBAKLtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "ec_5f55f06a1d82adce39be05fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Pocket Sandwich Theatre",
      "poi_type": "Restaurants",
      "poi_address": "1104 Elm St, Carrollton, TX 75006, USA",
      "poi_short_description": "Snug performance venue features boisterous dinner theater served up with American fare & a full bar.",
      "poi_long_description": "Snug performance venue features boisterous dinner theater served up with American fare & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-9309-70f9-945d-ec5a12b6f54b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9309-70f9-945d-ec5a12b6f54b",
        "storage_key": "property/5710961784651776/019f14fc-9309-70f9-945d-ec5a12b6f54b.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://www.pocketsandwich.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18418924393257921357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocket-sandwich-theatre",
      "poi_latitude": "32.9519015",
      "poi_longitude": "-96.9085228",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-821-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0fCzxOfToYRTWvq5CUqnf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_df944d19bac8a312721749c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Menas Tex-Mex Grill Cantina",
      "poi_type": "Restaurants",
      "poi_address": "2810 E Trinity Mls Rd Apt 197, Carrollton, TX 75006, USA",
      "poi_short_description": "Casual eatery featuring Tex Mex & traditional Mexican fare with outdoor seating & weekly live music.",
      "poi_long_description": "Casual eatery featuring Tex Mex & traditional Mexican fare with outdoor seating & weekly live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-864d-760c-bab1-e45e9010007e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-864d-760c-bab1-e45e9010007e",
        "storage_key": "property/5710961784651776/019f14fc-864d-760c-bab1-e45e9010007e.webp",
        "width": 640,
        "height": 416
      },
      "poi_business_url": "https://www.menastexmexgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10902504552385272812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menas-tex-mex-grill-cantina",
      "poi_latitude": "32.9848872",
      "poi_longitude": "-96.8544877",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-478-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xVR3h4kTIYR7NsAXyB6TZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_229ce81242fa70c6a45a48d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1213 E Trinity Mls Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Department-store chain stocking clothing, electronics, housewares, toys, pharmaceuticals, sporting goods, auto accessories, furniture and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-8c7e-72a8-bd1a-ac48bea8d13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8c7e-72a8-bd1a-ac48bea8d13c",
        "storage_key": "property/5710961784651776/019f14fc-8c7e-72a8-bd1a-ac48bea8d13c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1216-carrollton-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7593491239283835688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.985984",
      "poi_longitude": "-96.9059886",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-466-2228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMeeQPOQlTIYRKMON0gyAYWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_21b53b3eb029866dd547fbfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1253 E Trinity Mls Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-8bbe-72ce-9216-eed7e272d224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-8bbe-72ce-9216-eed7e272d224",
        "storage_key": "property/5710961784651776/019f14fc-8bbe-72ce-9216-eed7e272d224.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Carrollton/0550?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-550-_-na-_-0-_-0&y_source=1_MTE4NDUxMi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9829274495029706809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.986289",
      "poi_longitude": "-96.90258",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-446-0066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8UXE--YlTIYROYANVBOZaIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_48060173a74bec55201fdc3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "4112 N Josey Ln, Carrollton, TX 75007, USA",
      "poi_short_description": "Supermarket chain for groceries, organic products, a bakery, flowers, a meat counter and deli.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-97d2-70ed-a65b-7975eedf361d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-97d2-70ed-a65b-7975eedf361d",
        "storage_key": "property/5710961784651776/019f14fc-97d2-70ed-a65b-7975eedf361d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/carrollton/4112-n-josey-ln.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14556448501153750988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "33.0235029",
      "poi_longitude": "-96.8832886",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-394-4127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee95-74b9-83db-d1c607dde2a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee95-74b9-83db-d1c607dde2a8",
        "storage_key": "property/5710961784651776/019f14f9-ee95-74b9-83db-d1c607dde2a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaWUJ66klTIYRzF-J1snkAso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_75ac099c1126a1000c3c53ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Circle K | Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "2146 N Josey Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.circlek.com/store-locator/US/carrollton/2146-n-josey-ln/2741740?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1543828028885842633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k--gas-station",
      "poi_latitude": "32.973856",
      "poi_longitude": "-96.889306",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-323-5194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-e9d6-72ae-a4ef-df48a4700124.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-e9d6-72ae-a4ef-df48a4700124",
        "storage_key": "property/5710961784651776/019f14fc-e9d6-72ae-a4ef-df48a4700124.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cUji00nTIYRyToIqGnHbBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_54ddd45e3822cac815f7323b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Vintage House",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 E Belt Line Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "A historic pink house is the setting for this charming shop selling jewelry, luggage & gift items.",
      "poi_long_description": "A historic pink house is the setting for this charming shop selling jewelry, luggage & gift items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-90cd-7219-bee0-23ffa0f84e14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-90cd-7219-bee0-23ffa0f84e14",
        "storage_key": "property/5710961784651776/019f14fc-90cd-7219-bee0-23ffa0f84e14.webp",
        "width": 960,
        "height": 636
      },
      "poi_business_url": "http://www.shopthepinkhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619750671621879652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vintage-house",
      "poi_latitude": "32.9540152",
      "poi_longitude": "-96.9064431",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-242-5616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-1-Gvj0mTIYRZPe4bqeCehY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "ec_e8b668856462ae9e2d289186",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "A Honey of a Deal Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "1102 W Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-9fa3-775e-8a6d-6c9cfdecc5b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9fa3-775e-8a6d-6c9cfdecc5b0",
        "storage_key": "property/5710961784651776/019f14fc-9fa3-775e-8a6d-6c9cfdecc5b0.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "http://www.ahoneyofadealboutique.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8256970777792227710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-honey-of-a-deal-boutique",
      "poi_latitude": "32.95245",
      "poi_longitude": "-96.9082422",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-446-5654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwfoj6TwmTIYRfikW0yynlnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_0a883d6d0d261fbd0bcce0f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Blooms Candy & Soda Pop Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "1106 W Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "Whimsical, retro candy & soda store with a huge selection that includes taffy, bulk sweets & gifts.",
      "poi_long_description": "Whimsical, retro candy & soda store with a huge selection that includes taffy, bulk sweets & gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-a834-771d-92e2-808cc62cbb0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a834-771d-92e2-808cc62cbb0d",
        "storage_key": "property/5710961784651776/019f14fc-a834-771d-92e2-808cc62cbb0d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.candycarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15691137975977853962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blooms-candy--soda-pop-shop",
      "poi_latitude": "32.9523935",
      "poi_longitude": "-96.9083604",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-416-5230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxThi4zwmTIYRCkTNm9oewtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "candy_store"
    },
    {
      "id": "ec_a868ac2e0eb293819675e408",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Lost & Found Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "1014 S Broadway St #104, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-99b6-7159-be3f-c1e63ba8b8fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-99b6-7159-be3f-c1e63ba8b8fa",
        "storage_key": "property/5710961784651776/019f14fc-99b6-7159-be3f-c1e63ba8b8fa.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "https://lostandfoundtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5834978221271900180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lost--found-boutique",
      "poi_latitude": "32.9528869",
      "poi_longitude": "-96.9085398",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-503-8333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eeef-71de-837b-25ab27c6942c",
        "storage_key": "property/5710961784651776/019f14f9-eeef-71de-837b-25ab27c6942c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTdMCeNEnTIYRFGAN98YB-lA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "ec_13eb297f1b672a2a7592a354",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2620 N Josey Ln, Carrollton, TX 75007, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-995e-746e-8f88-dd3e18df16c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-995e-746e-8f88-dd3e18df16c2",
        "storage_key": "property/5710961784651776/019f14fc-995e-746e-8f88-dd3e18df16c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3675520676524282403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "32.9867999",
      "poi_longitude": "-96.8890441",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-701-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee95-74b9-83db-d1c607dde2a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee95-74b9-83db-d1c607dde2a8",
        "storage_key": "property/5710961784651776/019f14f9-ee95-74b9-83db-d1c607dde2a8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOf72edolTIYRI1LV4JQSAjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7f688bb4b61fd9fc36178bf6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Trinity Valley Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2710 N Josey Ln, Carrollton, TX 75007, USA",
      "poi_short_description": "Center featuring WinCo Foods, a farmers market, and retailers including Ross, Ulta, Petco, and DTLR.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-a24b-7139-bb6b-cb625744bb50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a24b-7139-bb6b-cb625744bb50",
        "storage_key": "property/5710961784651776/019f14fc-a24b-7139-bb6b-cb625744bb50.webp",
        "width": 1280,
        "height": 426
      },
      "poi_business_url": "http://www.tvcarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5856103900389013505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-valley-shopping-center",
      "poi_latitude": "32.9892614",
      "poi_longitude": "-96.8894043",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-954-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQ-869klTIYRAXh3bngPRVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_83208ab6c7ae7b10ac0c50e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Carrollton Elementary School",
      "poi_type": "Education",
      "poi_address": "1805 Pearl St, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://carrollton.cfbisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10084527877111916432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrollton-elementary-school",
      "poi_latitude": "32.9566587",
      "poi_longitude": "-96.8940603",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-968-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhwDMHGomTIYRkKfHkqxw84s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d7cc6043679fd2cb710101db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "DeWitt Perry Middle School",
      "poi_type": "Education",
      "poi_address": "1709 E Belt Line Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-a698-71fb-b1c5-7413bb6263c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a698-71fb-b1c5-7413bb6263c9",
        "storage_key": "property/5710961784651776/019f14fc-a698-71fb-b1c5-7413bb6263c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cfbisd.edu/schools/middle-schools/perry-middle-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12867138543514270685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dewitt-perry-middle-school",
      "poi_latitude": "32.9545523",
      "poi_longitude": "-96.8965979",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-968-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKaEe0kEmTIYR3bvnEVVCkbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_f24319a8e069e043f31cd5f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "RL Turner High School",
      "poi_type": "Education",
      "poi_address": "1600 S Josey Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-9cd8-70fe-a5ed-76931cf88721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9cd8-70fe-a5ed-76931cf88721",
        "storage_key": "property/5710961784651776/019f14fc-9cd8-70fe-a5ed-76931cf88721.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cfbisd.edu/schools/high-schools/turner-high-school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13634732576129140602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rl-turner-high-school",
      "poi_latitude": "32.9484841",
      "poi_longitude": "-96.8912985",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-968-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3x4-40QmTIYResefvwlNOL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_8aa5de0425ff3169686f63ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Good Elementary School",
      "poi_type": "Education",
      "poi_address": "1012 Study Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cfbisd.edu/schools/elementary-schools/good-elementary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16653512229267308439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-elementary-school",
      "poi_latitude": "32.970846",
      "poi_longitude": "-96.9087162",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-968-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1Q39ag8mTIYRl_8ZcCMpHec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0f5e40bd80bff1b330df1d00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Blanton Elementary School",
      "poi_type": "Education",
      "poi_address": "2525 Scott Mill Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-abb8-721a-a612-5297b5f02291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-abb8-721a-a612-5297b5f02291",
        "storage_key": "property/5710961784651776/019f14fc-abb8-721a-a612-5297b5f02291.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://blanton.cfbisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13955648638861323237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanton-elementary-school",
      "poi_latitude": "32.9836935",
      "poi_longitude": "-96.8856191",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-968-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpwKP59YlTIYR5St-MX9srME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_dea3d1c3bd560cb3a7f27453",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "CFBISD Child Development Academy",
      "poi_type": "Education",
      "poi_address": "2325 Heads Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cfbisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=829476005139533243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cfbisd-child-development-academy",
      "poi_latitude": "32.9745399",
      "poi_longitude": "-96.8737188",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-968-6034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp2cvMoEmTIYRu00NLAjkggs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_8e8386b637bbf510590eaba4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Rising Starz Learning Center",
      "poi_type": "Education",
      "poi_address": "1200 E Jackson Rd bldg 1, Carrollton, TX 75006, USA",
      "poi_short_description": "Child-care agency offering preschool and daycare services for infants and toddlers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ace4-705b-a4c7-4d3bb41128c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-ace4-705b-a4c7-4d3bb41128c8",
        "storage_key": "property/5710961784651776/019f14fc-ace4-705b-a4c7-4d3bb41128c8.webp",
        "width": 1110,
        "height": 671
      },
      "poi_business_url": "https://www.risingstarzchildcarecenter.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083363576450799941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rising-starz-learning-center",
      "poi_latitude": "32.9751945",
      "poi_longitude": "-96.9030708",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-466-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV_nDsAsmTIYRRVm6H9ZOyio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_919e7fce4dfa0e95c2035227",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "The St. Anthony School",
      "poi_type": "Education",
      "poi_address": "2030 N Denton Dr Suite 2, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-a825-722d-a861-3ac8445202b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-a825-722d-a861-3ac8445202b7",
        "storage_key": "property/5710961784651776/019f14fc-a825-722d-a861-3ac8445202b7.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "https://www.thestanthonyschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15803384302046907659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-st-anthony-school",
      "poi_latitude": "32.9701095",
      "poi_longitude": "-96.90653",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-443-1205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1RD_A4mTIYRC4199ErmUNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_89a699156a345a472426a871",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Dallas College Brookhaven Campus",
      "poi_type": "Education",
      "poi_address": "3939 Valley View Ln, Farmers Branch, TX 75244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-950f-71fa-8e0e-67184b01ade1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-950f-71fa-8e0e-67184b01ade1",
        "storage_key": "property/5710961784651776/019f14f9-950f-71fa-8e0e-67184b01ade1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dallascollege.edu/?utm_source=local&utm_medium=organic&utm_campaign=gmb&utm_content=bhc",
      "poi_directions_map_url": "https://maps.google.com/?cid=208398756898402828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-college-brookhaven-campus",
      "poi_latitude": "32.9292511",
      "poi_longitude": "-96.8500787",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-860-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb8_qFCQnTIYRDPKPtJBh5AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1126dde850da837edbef3e4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Parker University",
      "poi_type": "Education",
      "poi_address": "2540 Walnut Hill Ln, Dallas, TX 75229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-944a-7506-a6d4-dacc01ad0f8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-944a-7506-a6d4-dacc01ad0f8c",
        "storage_key": "property/5710961784651776/019f14f9-944a-7506-a6d4-dacc01ad0f8c.webp",
        "width": 1280,
        "height": 670
      },
      "poi_business_url": "https://www.parker.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11949648999134616964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parker-university",
      "poi_latitude": "32.8801185",
      "poi_longitude": "-96.8928565",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-902-3447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq0AxyGWdToYRhF0F6HOu1aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_f237e0209519835803e61974",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "3 Nations Brewing",
      "poi_type": "Entertainment",
      "poi_address": "1033 Vandergriff Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ad3a-71a8-8232-394de5dbb322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-ad3a-71a8-8232-394de5dbb322",
        "storage_key": "property/5710961784651776/019f14fc-ad3a-71a8-8232-394de5dbb322.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://3nationsbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16334268649776711549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3-nations-brewing",
      "poi_latitude": "32.9510887",
      "poi_longitude": "-96.906271",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 469-289-6062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJseaydbUnTIYRfYe9V8v6ruI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_fd5370f48de8da0fafee4504",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Texas Lumberjaxe Indoor Axe Throwing",
      "poi_type": "Entertainment",
      "poi_address": "1102 W Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "Casual venue featuring axe throwing lanes, games and trick-shot instruction. Owner and staff friendly and helpful, with free brownies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-af2f-7189-8867-6eae039ed5ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-af2f-7189-8867-6eae039ed5ce",
        "storage_key": "property/5710961784651776/019f14fc-af2f-7189-8867-6eae039ed5ce.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.texaslumberjaxe.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=986906453129492963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-lumberjaxe-indoor-axe-throwing",
      "poi_latitude": "32.95245",
      "poi_longitude": "-96.9082422",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-758-0083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fI--wgnTIYR4_lStTAysg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_19dec40be87f2bb63ff6e3e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Pocket Sandwich Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1104 Elm St, Carrollton, TX 75006, USA",
      "poi_short_description": "Snug performance venue features boisterous dinner theater served up with American fare & a full bar.",
      "poi_long_description": "Snug performance venue features boisterous dinner theater served up with American fare & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-9309-70f9-945d-ec5a12b6f54b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-9309-70f9-945d-ec5a12b6f54b",
        "storage_key": "property/5710961784651776/019f14fc-9309-70f9-945d-ec5a12b6f54b.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://www.pocketsandwich.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18418924393257921357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocket-sandwich-theatre",
      "poi_latitude": "32.9519015",
      "poi_longitude": "-96.9085228",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-821-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0fCzxOfToYRTWvq5CUqnf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_a52be61bc401f4d240588259",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "A W Perry Homestead Museum",
      "poi_type": "Entertainment",
      "poi_address": "1509 N Perry Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Restored, historic 1909 home & surrounding 13-acre park, open to the public for visits & tours.",
      "poi_long_description": "Restored, historic 1909 home & surrounding 13-acre park, open to the public for visits & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b1e9-779b-918b-a98913ec6f48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b1e9-779b-918b-a98913ec6f48",
        "storage_key": "property/5710961784651776/019f14fc-b1e9-779b-918b-a98913ec6f48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofcarrollton.com/departments/departments-g-p/parks-recreation/facilities/a-w-perry-homestead-museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496171444752880948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-w-perry-homestead-museum",
      "poi_latitude": "32.9584479",
      "poi_longitude": "-96.896306",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-466-6380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-53f05cf3f021.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-53f05cf3f021",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-53f05cf3f021.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJByMTEmsmTIYRNBVczmflhDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_60b9661551827ee85c2c4316",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Lemma Coffee Co - Carrollton",
      "poi_type": "Entertainment",
      "poi_address": "1014 S Broadway St #110, Carrollton, TX 75006, USA",
      "poi_short_description": "Cute shop for small-batch, freshly roasted beans for coffee on-site or to brew at home, plus food.",
      "poi_long_description": "Cute shop for small-batch, freshly roasted beans for coffee on-site or to brew at home, plus food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b2ba-73b3-87cb-eb3341ece4c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b2ba-73b3-87cb-eb3341ece4c2",
        "storage_key": "property/5710961784651776/019f14fc-b2ba-73b3-87cb-eb3341ece4c2.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.lemmacoffeeco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14013622164808826203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lemma-coffee-co---carrollton",
      "poi_latitude": "32.9527789",
      "poi_longitude": "-96.9083923",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-892-2022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-e9d5-7648-a28b-dddc4a98fc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-e9d5-7648-a28b-dddc4a98fc99",
        "storage_key": "property/5710961784651776/019f14fc-e9d5-7648-a28b-dddc4a98fc99.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJH7Mjtks1TIYRW334jRxjesI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_5aa8e12cdafd0fae8b96fd52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Babe's Chicken Dinner House",
      "poi_type": "Entertainment",
      "poi_address": "1006 W Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_long_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-5f33-718f-b867-8e4b910d0d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-5f33-718f-b867-8e4b910d0d03",
        "storage_key": "property/5710961784651776/019f14fc-5f33-718f-b867-8e4b910d0d03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739785872141058117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-chicken-dinner-house",
      "poi_latitude": "32.9528134",
      "poi_longitude": "-96.9077799",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-245-7773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee96-723b-9595-a62b405a9ef0",
        "storage_key": "property/5710961784651776/019f14f9-ee96-723b-9595-a62b405a9ef0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVJi_jwmTIYRRQCaFbysBSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_52618432819ffcb8c4cf3f7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Coded Lounge",
      "poi_type": "Entertainment",
      "poi_address": "2661 Midway Rd Apt 110, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b2c1-763c-9286-4654ea18d9a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b2c1-763c-9286-4654ea18d9a1",
        "storage_key": "property/5710961784651776/019f14fc-b2c1-763c-9286-4654ea18d9a1.webp",
        "width": 1280,
        "height": 466
      },
      "poi_business_url": "https://www.codedloungedfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7106084651601952550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coded-lounge",
      "poi_latitude": "32.9866651",
      "poi_longitude": "-96.8439149",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-294-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea37-762e-9bab-24bbd667c73c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea37-762e-9bab-24bbd667c73c",
        "storage_key": "property/5710961784651776/019f14fc-ea37-762e-9bab-24bbd667c73c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZgbJA4lTIYRJv-WSlfinWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lounge_bar"
    },
    {
      "id": "ec_e844d19edeb453d3dc3a51e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Historic Downtown Carrollton",
      "poi_type": "Entertainment",
      "poi_address": "1100 Elm St, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-af73-77cd-8929-b8aacd2c822b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-af73-77cd-8929-b8aacd2c822b",
        "storage_key": "property/5710961784651776/019f14fc-af73-77cd-8929-b8aacd2c822b.webp",
        "width": 663,
        "height": 373
      },
      "poi_business_url": "https://historicdowntowncarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12382897537512545165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-downtown-carrollton",
      "poi_latitude": "32.9519842",
      "poi_longitude": "-96.9086915",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-880-9855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76h86DwmTIYRjZt-9bPj2Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_13d9e018346bc09b1cddbb07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Studio Movie Grill",
      "poi_type": "Entertainment",
      "poi_address": "4800 State Hwy 121, The Colony, TX 75056, USA",
      "poi_short_description": "First-run, classic & kids' films, plus a varied American menu & cocktails brought to guests' seats.",
      "poi_long_description": "First-run, classic & kids' films, plus a varied American menu & cocktails brought to guests' seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b1e6-764b-b5ca-6ce35bef3d2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b1e6-764b-b5ca-6ce35bef3d2a",
        "storage_key": "property/5710961784651776/019f14fc-b1e6-764b-b5ca-6ce35bef3d2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.studiomoviegrill.com/the-colony?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=the%20colony",
      "poi_directions_map_url": "https://maps.google.com/?cid=8042399736907830264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-movie-grill",
      "poi_latitude": "33.0669733",
      "poi_longitude": "-96.8836353",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-405-8530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea35-7498-8b8a-5e037641e472.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea35-7498-8b8a-5e037641e472",
        "storage_key": "property/5710961784651776/019f14fc-ea35-7498-8b8a-5e037641e472.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbHEnCwlTIYR-BMWRPNXnG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ec6268e434a7a45d5b342329",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Carrollton Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4343 N Josey Ln, Carrollton, TX 75010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-bc22-7337-89c5-8864366723ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-bc22-7337-89c5-8864366723ec",
        "storage_key": "property/5710961784651776/019f14f9-bc22-7337-89c5-8864366723ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.crmc.health/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2207349218951134756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrollton-regional-medical-center",
      "poi_latitude": "33.0284751",
      "poi_longitude": "-96.8857549",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-492-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eefd-7628-9a36-ed21e1f3d81f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eefd-7628-9a36-ed21e1f3d81f",
        "storage_key": "property/5710961784651776/019f14f9-eefd-7628-9a36-ed21e1f3d81f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXClTAYlTIYRJH7RamsUoh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_b1f8a57386c740f3e62a3fe8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Baylor Scott & White Urgent Care+ Carrollton (Trinity Mills)",
      "poi_type": "Health and Wellness",
      "poi_address": "1213 E Trinity Mls Rd #100, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b957-707e-8500-88804a45508c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b957-707e-8500-88804a45508c",
        "storage_key": "property/5710961784651776/019f14fc-b957-707e-8500-88804a45508c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bswhealth.com/locations/urgent-care/uc-plus-carrollton-trinity-mills?utm_source=google-mybusiness&utm_medium=organic&utm_campaign=UC+CarrolltonTrinityMills&utm_content=main-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380413342334647380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care-carrollton-trinity-mills",
      "poi_latitude": "32.9854604",
      "poi_longitude": "-96.9064156",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-431-0820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8zfB_AlTIYRVPyIKHI0ctU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c6c64bef51e6f4be59482472",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Carrollton",
      "poi_type": "Health and Wellness",
      "poi_address": "1017 W Hebron Pkwy, Carrollton, TX 75010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b524-709d-a195-fd00869e6638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b524-709d-a195-fd00869e6638",
        "storage_key": "property/5710961784651776/019f14fc-b524-709d-a195-fd00869e6638.webp",
        "width": 1250,
        "height": 703
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/carrollton?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353388210943568661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---carrollton",
      "poi_latitude": "33.0199922",
      "poi_longitude": "-96.9171826",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-939-9495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg7Dni4ElTIYRFSv2azsxEtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_5e26cd8711f9b47091891cc9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2142 N Josey Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b56a-76f0-bae0-666c3f7b49d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b56a-76f0-bae0-666c3f7b49d5",
        "storage_key": "property/5710961784651776/019f14fc-b56a-76f0-bae0-666c3f7b49d5.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/carrollton-tx-pharmacies/2142-n-josey-ln-carrollton-tx-75006/storeid=6960?WT.mc_id=LS_GOOGLE_RX_6960",
      "poi_directions_map_url": "https://maps.google.com/?cid=17709725979803440666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.9729434",
      "poi_longitude": "-96.8891812",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-446-1915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea95-743b-8f7c-5d122fc67073",
        "storage_key": "property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe478rnAmTIYRGtawz_KVxfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_30e695d7118cb31c0bf365fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2141 N Josey Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b769-70dd-ab09-f88caefed0ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b769-70dd-ab09-f88caefed0ec",
        "storage_key": "property/5710961784651776/019f14fc-b769-70dd-ab09-f88caefed0ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2141+n+josey+ln-carrollton-tx-75006/id=3803",
      "poi_directions_map_url": "https://maps.google.com/?cid=707674619553877162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.9729704",
      "poi_longitude": "-96.8906364",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-323-5096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea95-743b-8f7c-5d122fc67073",
        "storage_key": "property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2x6znAmTIYRqowRK1Eq0gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9bafbb17a01912007f4a0f22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Albertsons Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2150 N Josey Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b722-7699-89bf-d9ff72f4546f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b722-7699-89bf-d9ff72f4546f",
        "storage_key": "property/5710961784651776/019f14fc-b722-7699-89bf-d9ff72f4546f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.pharmacy.albertsons.com/tx/carrollton/2150-n-josey-ln.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14288087248794881800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons-pharmacy",
      "poi_latitude": "32.9746399",
      "poi_longitude": "-96.8885266",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-446-8231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea95-743b-8f7c-5d122fc67073",
        "storage_key": "property/5710961784651776/019f14fc-ea95-743b-8f7c-5d122fc67073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61O65HkmTIYRCA81uKZ7ScY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c341690e990de49e7ff560b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "2810 E Trinity Mls Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-bb14-764f-8422-e4efed7bde44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-bb14-764f-8422-e4efed7bde44",
        "storage_key": "property/5710961784651776/019f14fc-bb14-764f-8422-e4efed7bde44.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/carrollton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11368980012737543636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "32.985073",
      "poi_longitude": "-96.8532714",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-416-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgx7f1BgkTIYR1L28DRa7xp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c97ff4aff5559441c879ac9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3065 N Josey Ln, Carrollton, TX 75007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-a6be-71f8-b0c9-1d21395c313c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-a6be-71f8-b0c9-1d21395c313c",
        "storage_key": "property/5710961784651776/019f14f9-a6be-71f8-b0c9-1d21395c313c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/carrollton-tx?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7296929292665029337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.9992506",
      "poi_longitude": "-96.8877804",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-217-9351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxX-u-bElTIYR2QJx6IfmQ2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_66a76f87f4e080887b8c0965",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "HOTWORX - Carrollton, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "2150 N Josey Ln Ste 128, Carrollton, TX 75006, USA",
      "poi_short_description": "Gym, fitness studio and workout spot with infrared saunas for cardio, Pilates and yoga.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-b924-70aa-bd60-ee4a6261f129.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-b924-70aa-bd60-ee4a6261f129",
        "storage_key": "property/5710961784651776/019f14fc-b924-70aa-bd60-ee4a6261f129.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/carrollton?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14637216376131107678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---carrollton-tx",
      "poi_latitude": "32.9751309",
      "poi_longitude": "-96.8893702",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-435-9679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXzE9p7QnTIYRXjvTJ77WIcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_df8a098d84769b8fc1071184",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "My Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1220 W Trinity Mills Rd Ste 320, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-baa6-77af-bdf8-fa32b3537239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-baa6-77af-bdf8-fa32b3537239",
        "storage_key": "property/5710961784651776/019f14fc-baa6-77af-bdf8-fa32b3537239.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mypilates.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15836368784443927564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-pilates-studio",
      "poi_latitude": "32.9839594",
      "poi_longitude": "-96.9179066",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-768-9211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwfP61aclTIYRDGzdOIEVxts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a9d64b00eb883a01b3a5af69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Pioneer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1199 S Main St, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-bc23-7658-a5cd-b8f711df5eb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-bc23-7658-a5cd-b8f711df5eb9",
        "storage_key": "property/5710961784651776/019f14fc-bc23-7658-a5cd-b8f711df5eb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cityofcarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8340234951545940913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-park",
      "poi_latitude": "32.9528152",
      "poi_longitude": "-96.9068863",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaJvwFwnTIYRsWsx_n93vnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1838744fe24d3efbbbf14434",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "W. J. Thomas Park, Aquatic Complex & Sports Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1955 N Perry Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Family recreation site with a splash park, shaded picnic areas, grills & a deck. Rest rooms on-site.",
      "poi_long_description": "Family recreation site with a splash park, shaded picnic areas, grills & a deck. Rest rooms on-site.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-bc20-74d4-98f3-6a6e6da87879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-bc20-74d4-98f3-6a6e6da87879",
        "storage_key": "property/5710961784651776/019f14fc-bc20-74d4-98f3-6a6e6da87879.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17466340898439318543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-j-thomas-park-aquatic-complex--sports-field",
      "poi_latitude": "32.9638894",
      "poi_longitude": "-96.9004778",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKT2lMBMmTIYRD0xaqYHoZPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_288e95be5133254c31aa9ffd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Mary Heads Carter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2320 Heads Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "Recreational green space with sizable synthetic turf playground & covered picnic spot.",
      "poi_long_description": "Recreational green space with sizable synthetic turf playground & covered picnic spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-bedd-72ad-ae05-c6bb5e99f1b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-bedd-72ad-ae05-c6bb5e99f1b6",
        "storage_key": "property/5710961784651776/019f14fc-bedd-72ad-ae05-c6bb5e99f1b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofcarrollton.com/Home/Components/FacilityDirectory/FacilityDirectory/48/380",
      "poi_directions_map_url": "https://maps.google.com/?cid=8787383702325812441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-heads-carter-park",
      "poi_latitude": "32.9751444",
      "poi_longitude": "-96.8720197",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-466-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgarH44MmTIYR2dwvcusO83k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_aeeba495954752978213f925",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Mill Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Valley Mill Park, 2100 Carmel Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c072-753f-9bf6-e486e44abf21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c072-753f-9bf6-e486e44abf21",
        "storage_key": "property/5710961784651776/019f14fc-c072-753f-9bf6-e486e44abf21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofcarrollton.com/departments/departments-g-p/parks-recreation/facilities/parks#Mill%20Valley%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1395763443846770614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-valley-park",
      "poi_latitude": "32.9722497",
      "poi_longitude": "-96.8854667",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xXz4U0nTIYRtm_2BHW_XhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_55573c7871788ba95abb6b26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Oak Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2537 Oak Creek Dr, Carrollton, TX 75007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c0db-7689-af87-347e2d172634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c0db-7689-af87-347e2d172634",
        "storage_key": "property/5710961784651776/019f14fc-c0db-7689-af87-347e2d172634.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofcarrollton.com/Home/Components/FacilityDirectory/FacilityDirectory/52/380",
      "poi_directions_map_url": "https://maps.google.com/?cid=1505257998495602542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-creek-park",
      "poi_latitude": "33.0172973",
      "poi_longitude": "-96.8530105",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUTwEvElTIYRblelpyzA4xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c8b04c60ab1667388c466a6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Josey Ranch Athletic Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1440 Keller Springs Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Park, playground and athletic complex with walking, biking and exercise trails, plus ponds for fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c195-769f-a666-bb9fe03b0433.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c195-769f-a666-bb9fe03b0433",
        "storage_key": "property/5710961784651776/019f14fc-c195-769f-a666-bb9fe03b0433.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofcarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1251184400472912199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "josey-ranch-athletic-complex",
      "poi_latitude": "32.9690118",
      "poi_longitude": "-96.8941714",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7q3Y20mTIYRR7GySpUZXRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_177b69621e1f0ec2b5b368b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Elm Fork Nature Preserve Trail Entrance",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2335 Sandy Lake Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "Quiet nature preserve offering a short trail for walks through woodlands with a small pond.",
      "poi_long_description": "Quiet nature preserve offering a short trail for walks through woodlands with a small pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c5ed-72eb-8b96-d4623089f6a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c5ed-72eb-8b96-d4623089f6a3",
        "storage_key": "property/5710961784651776/019f14fc-c5ed-72eb-8b96-d4623089f6a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofcarrollton.com/departments/departments-g-p/parks-recreation/facilities/elm-fork-nature-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=8216994316188148633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elm-fork-nature-preserve-trail-entrance",
      "poi_latitude": "32.954797",
      "poi_longitude": "-96.9365355",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9hP-70oTIYRmWPMicugCHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_4b06a5c71137550f7a9f1363",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "McInnish Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1845 Legends Tr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c848-7413-9813-6f6fb68e2f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c848-7413-9813-6f6fb68e2f6e",
        "storage_key": "property/5710961784651776/019f14fc-c848-7413-9813-6f6fb68e2f6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofcarrollton.com/dogparks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6403706093609893887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcinnish-dog-park",
      "poi_latitude": "32.9660053",
      "poi_longitude": "-96.9371203",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6b9iqLAoTIYR_z-fi8OI3lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_b09e498038bc00c86bdebb86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Rosemeade Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1330 E Rosemeade Pkwy, Carrollton, TX 75007, USA",
      "poi_short_description": "Pet-friendly enclave for dogs to socialize, with separate areas for big and small pets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-c90f-76ee-aab6-351784549c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-c90f-76ee-aab6-351784549c88",
        "storage_key": "property/5710961784651776/019f14fc-c90f-76ee-aab6-351784549c88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofcarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11605338446737692477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosemeade-dog-park",
      "poi_latitude": "33.0113028",
      "poi_longitude": "-96.9068939",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5bvopAlTIYRPdf7X9RxDqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_da60d4b13411afa1bda68f12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Keller Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2146 Kelly Blvd, Carrollton, TX 75006, USA",
      "poi_short_description": "Small, clean park offering a fenced playground for young children and a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-cbb8-7486-bdf1-73835b7290b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-cbb8-7486-bdf1-73835b7290b4",
        "storage_key": "property/5710961784651776/019f14fc-cbb8-7486-bdf1-73835b7290b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8696244860806120833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keller-springs-park",
      "poi_latitude": "32.9696945",
      "poi_longitude": "-96.877414",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-466-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-ee91-75ee-b214-70cb98fa83f3",
        "storage_key": "property/5710961784651776/019f14f9-ee91-75ee-b214-70cb98fa83f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaoujYcmTIYRgUUqUKBEr3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_0e536d28798b6602fe43c540",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Downtown Carrollton Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-cd44-7489-b0a6-2d6c7a7b3f2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-cd44-7489-b0a6-2d6c7a7b3f2a",
        "storage_key": "property/5710961784651776/019f14fc-cd44-7489-b0a6-2d6c7a7b3f2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/downtowncarrolltonstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1406712211691691942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-carrollton-station",
      "poi_latitude": "32.9544447",
      "poi_longitude": "-96.9082563",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-4dcj0mTIYRpl8Wr02lhRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_stop"
    },
    {
      "id": "ec_0c4b4b809968fba837d7e137",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Trinity Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "2525 Blanton Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-d32e-751a-94ef-31e8abf72718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-d32e-751a-94ef-31e8abf72718",
        "storage_key": "property/5710961784651776/019f14f9-d32e-751a-94ef-31e8abf72718.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/trinitymillsstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=777499669808973001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-mills",
      "poi_latitude": "32.98092",
      "poi_longitude": "-96.9264",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-f163-7315-81d4-5004b1546405.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-f163-7315-81d4-5004b1546405",
        "storage_key": "property/5710961784651776/019f14f9-f163-7315-81d4-5004b1546405.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbbbi1MvTIYRyYTyj9Q7ygo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_0ee0f35b77b1f30cbe1aca35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "North Carrollton/Frankford Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Carrollton, TX 75007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-d2c5-75a0-b907-237c6819293a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-d2c5-75a0-b907-237c6819293a",
        "storage_key": "property/5710961784651776/019f14f9-d2c5-75a0-b907-237c6819293a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/northcarrolltonfrankfordstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13466834264007583091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-carrolltonfrankford-station",
      "poi_latitude": "32.9917963",
      "poi_longitude": "-96.9370203",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLeK0L0QvTIYRcyU7q2nO47o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_abc28369389d94ebe7904e5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Farmers Branch Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "12800 Denton Dr, Farmers Branch, TX 75234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-d25e-7268-9ba9-229f327e1e37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-d25e-7268-9ba9-229f327e1e37",
        "storage_key": "property/5710961784651776/019f14fc-d25e-7268-9ba9-229f327e1e37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15862279034906579864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farmers-branch-station",
      "poi_latitude": "32.9218581",
      "poi_longitude": "-96.8967986",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea4e-76de-998a-6d8fbaced5ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea4e-76de-998a-6d8fbaced5ee",
        "storage_key": "property/5710961784651776/019f14fc-ea4e-76de-998a-6d8fbaced5ee.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5R9XLbgnTIYRmJO7g70iItw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_f67ef9d56a2bc9e450e3ce3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Addison Transit Center Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "4925 Arapaho Rd, Addison, TX 75001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-cc85-7382-a95b-f956b84eaa80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-cc85-7382-a95b-f956b84eaa80",
        "storage_key": "property/5710961784651776/019f14fc-cc85-7382-a95b-f956b84eaa80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17449744564337174352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addison-transit-center-park--ride",
      "poi_latitude": "32.9591524",
      "poi_longitude": "-96.8268596",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea4e-76de-998a-6d8fbaced5ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea4e-76de-998a-6d8fbaced5ee",
        "storage_key": "property/5710961784651776/019f14fc-ea4e-76de-998a-6d8fbaced5ee.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJAU61RochTIYRUOeegjryKfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_ee1cbd0ec9f2d5fab49911ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ce88-7509-9664-552b425013cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-ce88-7509-9664-552b425013cc",
        "storage_key": "property/5710961784651776/019f14fc-ce88-7509-9664-552b425013cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-f15e-776b-84b2-c42a1e77db6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-f15e-776b-84b2-c42a1e77db6b",
        "storage_key": "property/5710961784651776/019f14f9-f15e-776b-84b2-c42a1e77db6b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_1d63b076434424b42beb6aaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Carrollton City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1945 E Jackson Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-d2bd-7084-973e-c288b84113bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-d2bd-7084-973e-c288b84113bb",
        "storage_key": "property/5710961784651776/019f14fc-d2bd-7084-973e-c288b84113bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cityofcarrollton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10109697687903236543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrollton-city-hall",
      "poi_latitude": "32.9763488",
      "poi_longitude": "-96.8891525",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-466-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ea91-75c9-bf0c-bcbc94752934.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-ea91-75c9-bf0c-bcbc94752934",
        "storage_key": "property/5710961784651776/019f14fc-ea91-75c9-bf0c-bcbc94752934.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SA91XkmTIYRv3EP0nvcTIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_2fc38b1dfd3cfff97edd576e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Carrollton-Farmers Branch Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1445 N Perry Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-ce16-75ba-a9b8-9183e9e53743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-ce16-75ba-a9b8-9183e9e53743",
        "storage_key": "property/5710961784651776/019f14fc-ce16-75ba-a9b8-9183e9e53743.webp",
        "width": 1280,
        "height": 544
      },
      "poi_business_url": "http://www.cfbisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7766807663555931982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrollton-farmers-branch-independent-school-district",
      "poi_latitude": "32.9568343",
      "poi_longitude": "-96.8961802",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-968-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eee7-70bf-a171-fa187c76f3f1",
        "storage_key": "property/5710961784651776/019f14f9-eee7-70bf-a171-fa187c76f3f1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF22FMkQmTIYRTm8IcWs-yWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_9b84eed49df4003ec4a412ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Carrollton Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4343 N Josey Ln, Carrollton, TX 75010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-bc22-7337-89c5-8864366723ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-bc22-7337-89c5-8864366723ec",
        "storage_key": "property/5710961784651776/019f14f9-bc22-7337-89c5-8864366723ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.crmc.health/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2207349218951134756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrollton-regional-medical-center",
      "poi_latitude": "33.0284751",
      "poi_longitude": "-96.8857549",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-492-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eefd-7628-9a36-ed21e1f3d81f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eefd-7628-9a36-ed21e1f3d81f",
        "storage_key": "property/5710961784651776/019f14f9-eefd-7628-9a36-ed21e1f3d81f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXClTAYlTIYRJH7RamsUoh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_f367a028de8c09f6e3d86589",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "CyrusOne Carrollton",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1649 W Frankford Rd, Carrollton, TX 75007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-d38b-762b-98d1-33751cd32509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-d38b-762b-98d1-33751cd32509",
        "storage_key": "property/5710961784651776/019f14fc-d38b-762b-98d1-33751cd32509.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://cyrusone.com/locations/texas/dallas-texas-carrollton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8840508974956264043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyrusone-carrollton",
      "poi_latitude": "32.9937566",
      "poi_longitude": "-96.93120960000002",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-564-3198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTfnR5EvTIYRa7rr3RLMr3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_f1660bea1903a843481b188b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Schneider Electric",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1650 W Crosby Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-d38e-74d8-b976-479944c46a50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-d38e-74d8-b976-479944c46a50",
        "storage_key": "property/5710961784651776/019f14fc-d38e-74d8-b976-479944c46a50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.se.com/us/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7165713607270662516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schneider-electric",
      "poi_latitude": "32.9461816",
      "poi_longitude": "-96.9242235",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-342-5173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYXW75woTIYRdAGNa4-6cWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_46919d77b506ba32abeb7b1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Sanmina Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 W Crosby Rd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-d77d-701f-9c3e-e8d05ab0281e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-d77d-701f-9c3e-e8d05ab0281e",
        "storage_key": "property/5710961784651776/019f14fc-d77d-701f-9c3e-e8d05ab0281e.webp",
        "width": 1280,
        "height": 574
      },
      "poi_business_url": "http://www.sanmina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18149545677207203197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sanmina-corporation",
      "poi_latitude": "32.9458618",
      "poi_longitude": "-96.9106597",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-512-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70QR31oXTIYRfW2pDKIj4Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_4f3d319960fba83e277b75ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "Southland Industries",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1728 Briercroft Ct, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-dab4-779e-9f48-e5bb498da7d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-dab4-779e-9f48-e5bb498da7d0",
        "storage_key": "property/5710961784651776/019f14fc-dab4-779e-9f48-e5bb498da7d0.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "http://www.brandt.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3193376282454289618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southland-industries",
      "poi_latitude": "32.9390617",
      "poi_longitude": "-96.9287413",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-395-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VYBUoQoTIYR0mzYRc8mUSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_7cc7c94d1cfc89acee1f9f12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "AER Manufacturing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1605 Surveyor Blvd, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-da8d-7718-9330-02527ace832b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-da8d-7718-9330-02527ace832b",
        "storage_key": "property/5710961784651776/019f14fc-da8d-7718-9330-02527ace832b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.aermanufacturing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1891324117317679122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aer-manufacturing",
      "poi_latitude": "32.9589468",
      "poi_longitude": "-96.8474541",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-621-0545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAfG_dbgmTIYREnjZl0NVPxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_80ef3aafe5a8ee727511317a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "MB2 Dental",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2403 Lacy Ln, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-de45-745b-bfbe-9d7c6925f974.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-de45-745b-bfbe-9d7c6925f974",
        "storage_key": "property/5710961784651776/019f14fc-de45-745b-bfbe-9d7c6925f974.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://mb2dental.com/?utm_campaign=25164142-MB2_Brand_Awareness&utm_source=google&utm_medium=business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=16717308738876185116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mb2-dental",
      "poi_latitude": "32.9222685",
      "poi_longitude": "-96.9275972",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-869-3789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38aLaXooTIYRHJo_1bnP_-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3cb19f059b6e470b466f35f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "poi_name": "VRM Mortgage Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4100 International Pkwy Ste 1000, Carrollton, TX 75007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14fc-dbc1-71b4-9a62-2fb486a8eb17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fc-dbc1-71b4-9a62-2fb486a8eb17",
        "storage_key": "property/5710961784651776/019f14fc-dbc1-71b4-9a62-2fb486a8eb17.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.vrmco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14082864940688260822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vrm-mortgage-services",
      "poi_latitude": "33.0210875",
      "poi_longitude": "-96.8457367",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-843-8334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-eef5-77ed-aabd-4e677d45331a",
        "storage_key": "property/5710961784651776/019f14f9-eef5-77ed-aabd-4e677d45331a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwdZynwkTIYR1r6GoQxjcMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b03d90c7-f04e-46ae-a7eb-191296cc1016",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b28cde77-5575-498b-a513-599d561fba49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f081de59-e9a2-41ed-94d7-ea157102f5f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_62c23584-0d82-4072-92d8-4348742c80c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7940c9bc-debd-4a5f-9943-d185ba3099f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_c70d3ee7-58dc-4220-9a0d-dd01819fd1f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b320e947-04bd-43b6-890b-d4de77c6fccd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2c7d63e0-f5af-4153-bd35-6a25ce9b7538",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "rating": "5.0",
      "name": "Lajuane Bailey",
      "text": "I have had a wonderful experience, but the Halloween party today was the icing on the cake! It was so much fun seeing everyone come together in their creative costumes and celebrate. The management team went all out with decorations and activities, creating a festive and memorable evening for all the residents. The have regular events.\nBeyond the fun social events, the apartments themselves are fantastic. My unit has a great layout with plenty of natural light, and any maintenance requests I've had have been handled quickly and professionally by the vigilant staff. The location is also perfect, offering convenient access to the new rail line is 4 stop from DFW and the other direction takes you to plano. Downtown dallas is 6 stop south. I have lived in alot of places but this new managment is fire and the office staff is great. Im a hard reviewer so for me to say its a good place to live says alot.",
      "date": "2025-10-25",
      "title": ""
    },
    {
      "id": "custom_323d6d10-e3e7-4f03-83dc-1e10b49a488d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "rating": "5.0",
      "name": "Allan Pivaral",
      "text": "I love my apartment.  Such a pleasant place to live, relax after a busy day of work, and enjoy a cup of coffee in my balcony. Sara and Stephanie at the front office AMAZING. Community well maintained, and clean. I urge everyone to come to get your apartments home here and enjoy the different beautiful amenities such as the gymnasium, pool, BBQ grill, and more.",
      "date": "2025-08-26",
      "title": ""
    },
    {
      "id": "custom_bc93c54f-a1b9-4ff8-9cbc-6e471b318277",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "rating": "5.0",
      "name": "S P",
      "text": "I’ve had a fantastic experience living at Switchyard Apartments. The community is clean, modern, and well maintained, and the location is incredibly convenient. The apartments are thoughtfully designed with great amenities that make everyday living comfortable and enjoyable. Management and maintenance are responsive, professional, and genuinely care about residents, which makes a huge difference. I feel safe, comfortable, and happy calling Switchyard home. I would highly recommend it to anyone looking for a great place to live!",
      "date": "2026-01-19",
      "title": ""
    },
    {
      "id": "custom_db6b7b1a-70b0-4c79-8f54-051e0d386831",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "rating": "5.0",
      "name": "Ryan Thompson",
      "text": "From the very first tour at Switchyard, Cristina Rivas made the experience feel personal and genuine. She was incredibly warm, welcoming, and took the time to answer every question without ever making me feel rushed or pressured. Apartment searching can be stressful, but Cristina made the process feel exciting instead of overwhelming.\nWhat stood out most was how much she truly cared. Her follow-up calls, emails, and attention to detail showed that she goes above and beyond for people, not just as a leasing agent but as someone who genuinely wants you to feel confident in your decision. That kind of personal touch is rare and it made a huge impression on me.\nSwitchyard itself is a beautiful community, but people like Cristina are what really make a place stand out. She brought warmth and professionalism that you don’t often find, and it made the entire experience memorable. Even if I had toured ten other places, Cristina made Switchyard impossible to forget.",
      "date": "2026-04-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_7c7d7f7fdb980f0980d07892",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f14c3-825d-77aa-ac0f-a057546337f7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-825d-77aa-ac0f-a057546337f7",
        "storage_key": "property/5710961784651776/019f14c3-825d-77aa-ac0f-a057546337f7.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Switchyard Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/VmU41EG9eLg"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-f7d7-75be-9be0-a6f77ac2f5ff",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "switchyard",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776"
    },
    {
      "lead_collector_id": "0198aa45-f83b-7269-931c-61fc723873e7",
      "lead_source": "FACEBOOK_ADS",
      "name": "switchyard",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776"
    },
    {
      "lead_collector_id": "0198aa45-f89f-7568-8f75-80ac960a0241",
      "lead_source": "LANDING_PAGE",
      "name": "switchyard",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-carrollton-tx-287",
      "search_query": "apartments with in-unit laundry Carrollton TX",
      "category": "",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry in Carrollton, TX. Conveniently located in Downtown Carrollton, explore Switchyard's modern living options.",
      "page_copy": "Welcome to Switchyard, where you can enjoy the comfort of apartments with in-unit laundry in Carrollton, TX. Situated in the vibrant Downtown Carrollton area, our community offers a range of floor plans including studio, one-bedroom, and two-bedroom options. Each apartment is equipped with modern amenities such as smart locks and high-end finishes, making it the perfect choice for those seeking convenience and style.\n\nAt Switchyard, residents benefit from an array of luxury features beyond in-unit laundry, including a fitness center and a cozy outdoor lounge. Our gated community ensures a secure and peaceful environment, perfect for anyone looking to enjoy the best of urban living with suburban charm. Schedule a tour today to experience how Switchyard can be your perfect home in Carrollton, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Carrollton",
      "seo_description": "Discover Switchyard in Carrollton, TX offering stylish apartments with in-unit laundry and modern amenities. Explore our availability today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-downtown-carrollton-627",
      "search_query": "air conditioned apartments in Downtown Carrollton",
      "category": "",
      "h1_title": "Air Conditioned Apartments in Carrollton",
      "h2_subtitle": "Live comfortably in air conditioned apartments in Downtown Carrollton. Switchyard offers modern amenities in a central location.",
      "page_copy": "Experience the comfort of air conditioned apartments at Switchyard, located in the heart of Downtown Carrollton. Our community offers a range of floor plans, including studios and spacious one and two-bedroom apartments, each equipped with air conditioning to ensure your comfort in every season. Nestled in Carrollton's vibrant downtown, Switchyard provides convenient access to local shops, dining, and entertainment.\n\nIn addition to air conditioning, residents at Switchyard enjoy a variety of upscale amenities. From our state-of-the-art fitness center to the relaxing outdoor lounge area, there's something for everyone. Each apartment also includes features like a fully-equipped eat-in kitchen and smart home technology, making Switchyard the ideal choice for modern urban living in Carrollton, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Carrollton, TX",
      "seo_description": "Enjoy air conditioned comfort at Switchyard in Downtown Carrollton. Discover modern apartments with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "pool-apartments-dallas-county-83",
      "search_query": "pool apartments in Dallas County",
      "category": "",
      "h1_title": "Pool Apartments in Dallas County",
      "h2_subtitle": "Discover pool apartments in Dallas County at Switchyard. Enjoy a modern living experience in Carrollton, TX, with luxurious amenities.",
      "page_copy": "Welcome to Switchyard, where poolside relaxation meets modern living in Dallas County. Our apartments offer a refreshing pool experience, perfect for soaking up the Texas sun. Located in the charming Downtown Carrollton area, every apartment in our community, ranging from studios to two-bedrooms, boasts stylish interiors and premium features like smart locks, making it a premier choice in Dallas County.\n\nSwitchyard's pool area is just one of the many luxury amenities available to our residents. Besides enjoying the water, you can work out in our fitness center, entertain in our outdoor lounge, or unwind in an island kitchen designed for both convenience and elegance. Discover more about apartment living with a luxurious pool in Dallas County at Switchyard today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Dallas County, TX",
      "seo_description": "Explore Switchyard's pool apartments in Dallas County, TX. Enjoy luxury living with modern amenities in a prime Downtown Carrollton location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartment-with-dishwasher-carrollton-tx-39",
      "search_query": "apartment with dishwasher in Carrollton TX",
      "category": "",
      "h1_title": "Apartment with Dishwasher in Carrollton",
      "h2_subtitle": "Find your next apartment with a dishwasher in Carrollton, TX at Switchyard. Experience modern living with top amenities and a central location.",
      "page_copy": "Discover the convenience of living in an apartment with a dishwasher at Switchyard in Carrollton, TX. Our community offers a range of thoughtfully designed floor plans, from studios to spacious two-bedroom units, all featuring modern conveniences such as a dishwasher in the kitchen. Located in the heart of vibrant Downtown Carrollton, Switchyard provides an unmatched living experience with easy access to local hotspots.\n\nBeyond the convenience of a dishwasher, Switchyard offers a wealth of amenities designed to elevate your lifestyle. Enjoy access to our fully-equipped fitness center, relax in the inviting outdoor lounge, and benefit from smart technologies such as smart locks in every apartment. Come explore Switchyard and see why it's the perfect place to find an apartment with a dishwasher in Carrollton, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dishwasher in Carrollton, TX",
      "seo_description": "Find Switchyard's apartments with dishwashers in Carrollton, TX. Enjoy modern amenities in a prime Downtown location. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-near-downtown-carrollton-2",
      "search_query": "pet-friendly apartments near Downtown Carrollton",
      "category": "",
      "h1_title": "Pet-Friendly Apartments Near Downtown",
      "h2_subtitle": "Explore pet-friendly apartments near Downtown Carrollton. Switchyard offers pet-friendly living with modern amenities and a convenient location.",
      "page_copy": "At Switchyard, we know pets are part of the family, which is why we offer pet-friendly apartments near Downtown Carrollton. Located in this vibrant neighborhood, our community welcomes pets, ensuring they feel right at home. Choose from a variety of floor plans, including studios and larger apartments, all designed with both you and your pet's comfort in mind.\n\nSwitchyard’s location in Downtown Carrollton provides easy access to local parks and walking trails, perfect for daily strolls with your furry friend. Our modern amenities, which include an outdoor lounge and a fitness center, offer plenty of activity options for you and leisure spaces for your pet. Discover a welcoming environment for you and your pets at Switchyard today, and experience the joys of pet-friendly living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Downtown Carrollton",
      "seo_description": "Discover pet-friendly living at Switchyard near Downtown Carrollton. Enjoy modern amenities and a prime location for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-downtown-carrollton-445",
      "search_query": "1 bedroom apartments downtown carrollton",
      "category": "",
      "h1_title": "1 Bedroom Apartments Downtown Carrollton",
      "h2_subtitle": "Find 1 bedroom apartments in Downtown Carrollton at Switchyard. Enjoy a modern living experience with convenient access to city amenities.",
      "page_copy": "Looking for 1 bedroom apartments in Downtown Carrollton? Switchyard offers stylish and comfortable one-bedroom layouts perfect for urban living. Nestled in the heart of Downtown Carrollton, our community combines convenience with high-end amenities like smart locks and a well-equipped fitness center, ensuring you have everything you need right at your doorstep.\n\nBeyond the walls of your one-bedroom apartment, enjoy the vibrant community and local events that Downtown Carrollton has to offer. Our location provides easy access to shopping, dining, and entertainment, making it the ideal place for those who love city life. Experience the best of what Downtown Carrollton has to offer by making a one-bedroom apartment at Switchyard your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Downtown Carrollton",
      "seo_description": "Explore 1 bedroom apartments at Switchyard, located in Downtown Carrollton. Enjoy modern amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-carrollton-tx-392",
      "search_query": "2 bedroom apartments in carrollton tx",
      "category": "",
      "h1_title": "2 Bedroom Apartments in Carrollton, TX",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Carrollton, TX at Switchyard. Enjoy modern amenities and a vibrant community lifestyle.",
      "page_copy": "Explore the spacious 2 bedroom apartments offered at Switchyard in Carrollton, TX. Perfect for small families or roommates, our two-bedroom units provide ample space and modern finishes that ensure comfort and style. Each apartment is designed with a contemporary layout that includes smart features like smart locks, framed mirrors, and an island kitchen, all enhancing your living experience.\n\nSituated in the dynamic neighborhood of Downtown Carrollton, Switchyard offers the perfect blend of convenience and community. Whether enjoying a meal at a nearby eatery or attending local events, you'll be steps away from vibrant city life. Our community amenities, such as a fitness center and gated access, provide security and variety for an enhanced living experience. Discover why our two-bedroom apartments in Carrollton, TX, are the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Carrollton, TX",
      "seo_description": "Find spacious 2 bedroom apartments at Switchyard in Carrollton, TX. Enjoy modern amenities and vibrant community living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "studio-apartments-near-dallas-county-184",
      "search_query": "studio apartments near dallas county",
      "category": "",
      "h1_title": "Studio Apartments Near Dallas County",
      "h2_subtitle": "Discover stylish studio apartments near Dallas County at Switchyard. Enjoy modern amenities and a convenient location close to downtown.",
      "page_copy": "For those seeking studio apartments near Dallas County, look no further than Switchyard in Carrollton, TX. Our studios offer innovative and open layouts designed to suit a modern lifestyle. Each unit comes equipped with contemporary features like smart locks and an island kitchen, providing both convenience and style.\n\nLocated in the heart of Downtown Carrollton, residents have access to a vibrant community with numerous dining, entertainment, and shopping options just around the corner. Whether you're a young professional or simply appreciate efficient living, our studio apartments provide a perfect base close to both Dallas County and the city's bustling core. Experience the optimal blend of comfort and urban living at Switchyard.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near Dallas County",
      "seo_description": "Explore studio apartments at Switchyard near Dallas County. Enjoy modern living with stylish amenities and a prime location in Carrollton, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartments-near-mary-immaculate-catholic-school-carrollton-517",
      "search_query": "apartments near Mary Immaculate Catholic School Carrollton",
      "category": "",
      "h1_title": "Apartments Near Mary Immaculate School",
      "h2_subtitle": "Discover prime apartments near Mary Immaculate Catholic School in Carrollton. Enjoy convenience and modern amenities at Switchyard.",
      "page_copy": "Searching for apartments near Mary Immaculate Catholic School in Carrollton? Switchyard offers the perfect solution with a range of floor plans designed to meet your needs. Choose from studio, one-bedroom, or two-bedroom layouts, all featuring modern amenities like smart locks, an eat-in kitchen, and a welcoming outdoor lounge, ensuring a convenient and stylish living environment.\n\nLocated in the vibrant setting of Downtown Carrollton, Switchyard provides easy access to local attractions, schools, and essential services. Our community fosters a warm, lively atmosphere with access to nearby shopping and dining, making it an excellent choice for families and professionals alike. Experience the perfect mix of location, comfort, and lifestyle at Switchyard, all within reach of Mary Immaculate Catholic School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mary Immaculate School",
      "seo_description": "Find apartments at Switchyard near Mary Immaculate Catholic School in Carrollton, TX. Enjoy modern living with convenient access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "carrollton-farmers-branch-isd-apartments-dallas-county-278",
      "search_query": "Carrollton-Farmers Branch ISD apartments in Dallas County",
      "category": "",
      "h1_title": "Carrollton-Farmers Branch ISD Apartments",
      "h2_subtitle": "Discover apartments within the Carrollton-Farmers Branch ISD in Dallas County. Experience a vibrant community with modern amenities at Switchyard.",
      "page_copy": "Switchyard offers ideal living options for families seeking apartments within the Carrollton-Farmers Branch ISD in Dallas County. With a variety of floor plans, including one-bedroom, two-bedroom, and studio options, our apartments are designed with modern conveniences like smart locks and island kitchens, ensuring a comfortable and stylish environment.\n\nLocated in the lively heart of Downtown Carrollton, Switchyard provides residents with easy access to top-quality schools, shopping, and dining. The vibrant community, combined with our amenities such as a fitness center and inviting outdoor lounge, creates a perfect setting for families and individuals who value education and lifestyle. Embrace the benefits of living in a community catered to those within the Carrollton-Farmers Branch ISD at Switchyard.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Carrollton-Farmers Branch ISD Apartments",
      "seo_description": "Find modern living at Switchyard in Dallas County. Ideal for families within Carrollton-Farmers Branch ISD, offering convenient amenities and vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartments-near-prince-of-peace-christian-school-tx-119",
      "search_query": "apartments by Prince of Peace Christian School & Early Learning Center TX",
      "category": "",
      "h1_title": "Apartments by Prince of Peace Christian School",
      "h2_subtitle": "Explore apartments conveniently located by Prince of Peace Christian School & Early Learning Center in TX. Find your new home at Switchyard.",
      "page_copy": "Switchyard provides an excellent option for those searching for apartments by Prince of Peace Christian School & Early Learning Center in Texas. Our community offers a variety of floor plans including studios, one-bedroom, and two-bedroom layouts, all equipped with contemporary features such as smart locks and an island kitchen.\n\nSituated in the vibrant Downtown Carrollton area, Switchyard ensures that residents are close to top educational facilities, along with numerous dining and entertainment options. Our community amenities, including a fitness center and outdoor lounge, complement the convenient location, making Switchyard an ideal choice for families seeking proximity to quality education and a modern living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Prince of Peace Christian School TX",
      "seo_description": "Discover modern apartments near Prince of Peace Christian School in TX. Switchyard offers convenience and a vibrant community in downtown Carrollton.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartments-close-to-re-good-elementary-carrollton-165",
      "search_query": "apartments close to R E Good Elementary Carrollton",
      "category": "",
      "h1_title": "Apartments Close to R E Good Elementary",
      "h2_subtitle": "Find convenient apartments close to R E Good Elementary in Carrollton. Enjoy modern living at Switchyard with easy access to local schools.",
      "page_copy": "If you're looking for apartments close to R E Good Elementary in Carrollton, consider Switchyard as your next home. We offer a variety of floor plans, from studios to two-bedroom layouts, each designed with modern amenities like eat-in kitchens and smart locks, to provide comfort and convenience.\n\nLocated in bustling Downtown Carrollton, Switchyard gives residents swift access to top educational facilities, including R E Good Elementary. Our community fosters a lively environment with amenities such as a fitness center and a relaxing outdoor lounge. With nearby shopping and dining, Switchyard is the perfect blend of community atmosphere and urban convenience, ensuring an enriching living experience for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to R E Good Elementary",
      "seo_description": "Discover modern living at Switchyard, close to R E Good Elementary in Carrollton. Enjoy convenient amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "carrollton-apartments-near-westwood-school-814",
      "search_query": "Carrollton apartments near Westwood School",
      "category": "",
      "h1_title": "Carrollton Apartments Near Westwood School",
      "h2_subtitle": "Explore Carrollton apartments conveniently near Westwood School. Enjoy community life and modern amenities at Switchyard.",
      "page_copy": "Switchyard offers the perfect solution for families searching for Carrollton apartments near Westwood School. Choose from our array of floor plans, including studios, one-bedroom, and two-bedroom apartments that feature contemporary amenities like framed mirrors and island kitchens, providing a stylish and functional living environment.\n\nNestled in the vibrant community of Downtown Carrollton, Switchyard ensures easy access to Westwood School and other local conveniences. Residents can indulge in a range of amenities such as a gated entry, fitness center, and inviting outdoor lounge. With proximity to shopping, dining, and educational facilities, Switchyard is an ideal location for both families and professionals seeking dynamic living in Carrollton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Carrollton Apartments Near Westwood School",
      "seo_description": "Discover Switchyard apartments in Carrollton near Westwood School. Enjoy modern amenities and vibrant community living in downtown Carrollton.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "carrollton-farmers-branch-isd-high-school-apartments-817",
      "search_query": "Carrollton-Farmers Branch ISD high school apartments",
      "category": "",
      "h1_title": "Apartments Near Carrollton-Farmers Branch ISD High Schools",
      "h2_subtitle": "Discover modern living with apartments near Carrollton-Farmers Branch ISD high schools. Enjoy vibrant community life at Switchyard.",
      "page_copy": "For families in search of convenient living options near Carrollton-Farmers Branch ISD high schools, Switchyard offers an array of desirable apartments. Our selection includes studio, one-bedroom, and two-bedroom layouts, each boasting contemporary features like eat-in kitchens and smart locks, designed to enhance everyday living.\n\nLocated in Downtown Carrollton, Switchyard provides residents with quick access to several Carrollton-Farmers Branch ISD high schools, along with a variety of local amenities. The community features such as a fitness center and outdoor lounge, plus gated access, make it an appealing choice for those prioritizing both security and lifestyle. Embrace the synergy of a lively city atmosphere and the comforts of home at Switchyard.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cars, Branch ISD High School Apartments",
      "seo_description": "Find Switchyard apartments in Carrollton near ISD high schools. Enjoy modern living with access to educational and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "jesuit-college-preparatory-school-nearby-apartments-carrollton-172",
      "search_query": "Jesuit College Preparatory School nearby apartments in Carrollton",
      "category": "",
      "h1_title": "Apartments Near Jesuit College Preparatory School",
      "h2_subtitle": "Find excellent living with apartments near Jesuit College Preparatory School in Carrollton. Experience a vibrant community at Switchyard.",
      "page_copy": "Switchyard is the ideal residence for those seeking apartments near Jesuit College Preparatory School in Carrollton. Our community offers a variety of floor plans, including studio, one-bedroom, and two-bedroom options, each equipped with modern amenities like island kitchens and smart locks, aimed at providing a comfortable and stylish living experience.\n\nLocated in Downtown Carrollton, Switchyard ensures residents have easy access to Jesuit College Preparatory School and other local facilities. With amenities such as a private fitness center, a welcoming outdoor lounge, and secure gated access, residents enjoy both convenience and leisure. Positioned amidst vibrant shopping and dining options, Switchyard presents an ideal living environment for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jesuit College Prep School",
      "seo_description": "Discover Switchyard apartments near Jesuit College Preparatory School in Carrollton. Enjoy modern living with vibrant community settings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "dallas-county-apartments-near-trinity-christian-academy-998",
      "search_query": "Dallas County apartments near Trinity Christian Academy",
      "category": "",
      "h1_title": "Apartments Near Trinity Christian Academy",
      "h2_subtitle": "Discover Dallas County apartments conveniently located near Trinity Christian Academy. Experience vibrant living at Switchyard.",
      "page_copy": "For those searching for Dallas County apartments near Trinity Christian Academy, Switchyard presents an excellent option. Our community offers an array of thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, each featuring modern amenities such as smart locks, eat-in kitchens, and framed mirrors, ensuring a blend of style and convenience.\n\nPositioned in the heart of Downtown Carrollton, Switchyard provides easy commuting options to Trinity Christian Academy. Residents can also enjoy community perks like an outdoor lounge, fitness center, and gated entry. With close proximity to shopping, dining, and education, Switchyard is ideal for families and anyone seeking a connected lifestyle in Dallas County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dallas County Apts Near Trinity Christian Academy",
      "seo_description": "Find Switchyard's vibrant apartments near Trinity Christian Academy in Dallas County. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5710961784651776",
      "source": "custom",
      "page_item_url": "apartments-near-oak-crest-private-school-carrollton-877",
      "search_query": "apartments near Oak Crest Private School Carrollton",
      "category": "",
      "h1_title": "Apartments Near Oak Crest Private School",
      "h2_subtitle": "Explore modern living in Carrollton with apartments near Oak Crest Private School. Enjoy community amenities at Switchyard.",
      "page_copy": "Switchyard in Carrollton offers a premier living experience for those seeking apartments near Oak Crest Private School. Our property features a variety of floor plans, including studios, one-bedroom, and two-bedroom units, all equipped with high-end amenities such as island kitchens and smart locks, designed to enhance your living environment.\n\nLocated in the vibrant area of Downtown Carrollton, Switchyard provides convenient access to Oak Crest Private School, making it an excellent choice for families. Residents benefit from community amenities like a fitness center, an inviting outdoor lounge, and gated security. With close proximity to both education and leisure, Switchyard serves as the perfect backdrop for a balanced lifestyle in Carrollton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with bar stools.",
        "public_id": "019f6c10-d7fc-71e9-a196-13abb9a7d7f0",
        "storage_key": "property/5710961784651776/019f6c10-d7fc-71e9-a196-13abb9a7d7f0.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Oak Crest Private School Carrollton",
      "seo_description": "Check out Switchyard apartments near Oak Crest Private School in Carrollton. Discover modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2195"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470844"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a49\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a49\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4881703"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJ2QLJS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443948917"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "4f14be8d11f1ddcf"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dzlpog24wg4"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/5baf6d3d-0dac-41ab-8e40-cd26a009b91b"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "469-457-4286"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRyWWV0QlpjZWpnblJzUDJzM05Ocmc9PSIsInZhbHVlIjoiZmQrMEZZc2tZSktmbTlqemE1TTRPUT09IiwibWFjIjoiYzhkYzc4M2VlOTVhNzA4YzhjNTAyNTdmZGViOTk5ZTRlM2M4N2Y2YTlkNGVjNzM0NzU3NTBmOWRkZjA5MzAxNyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2195",
  "custom_repli_id": "2376470844",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a49\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a49\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4881703",
  "custom_google_gtm_id": "GTM-PJ2QLJS",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443948917",
  "custom_knock_community_id": "4f14be8d11f1ddcf",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dzlpog24wg4",
  "custom_self_guided_tour_url": "https://selftournow.com/property/5baf6d3d-0dac-41ab-8e40-cd26a009b91b",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "469-457-4286",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRyWWV0QlpjZWpnblJzUDJzM05Ocmc9PSIsInZhbHVlIjoiZmQrMEZZc2tZSktmbTlqemE1TTRPUT09IiwibWFjIjoiYzhkYzc4M2VlOTVhNzA4YzhjNTAyNTdmZGViOTk5ZTRlM2M4N2Y2YTlkNGVjNzM0NzU3NTBmOWRkZjA5MzAxNyJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-30T22:31:08.498Z';
